<template>
  <div>
    <cargo-dialog
      ref="cargoDialog"
      custom-class="bill-payment-dialog"
      :visible="visible"
      :title="title"
      :width="!ifJc && customFields && customFields.length > 0 ? '1350px' : '960px'"
      top="5vh"
      :can-maximize="source === 'append'"
      :can-minimize="source === 'append'"
      :source="source"
      class="grid-view"
      @close="cancel"
    >
      <div class="tabs-container">
        <el-tabs :active-name="activeTabName" @tab-click="handleClick">
          <el-tab-pane :label="$t('CargoMsg.Cargo_ApplicationForm')" name="applicationForm" style="width: 98%">
            <el-form
              :inline="true"
              style="width: 100%"
              :label-width="$selectByLang('90px', '115px')"
              label-position="left"
              :disabled="readonly"
            >
              <div style="display: flex;flex-direction: row;">
                <div style="flex: 1">
                  <div class="el-form-item-wrapper">
                    <el-form-item :label="$t('Payment.applicationNo')">
                      <el-input v-model="billPayment.billPaymentNo" no="1" disabled="disabled" style="width: 170px;">
                        <i
                          v-if="billPayment.billPaymentNo"
                          slot="suffix"
                          class="el-icon-search"
                          style="padding: 5px;color: #1F75D5;cursor: pointer;"
                          @click="billPaymentNoLink"
                        />
                      </el-input>
                    </el-form-item>
                    <el-form-item :label="$t('Payment.status')" label-width="50px">
                      <span>{{ stateText }}</span>
                    </el-form-item>
                  </div>
                  <el-form-item :label="$t('Payment.settleAccountsTo')">
                    <div style="display: flex">
                      <cargo-advance-select
                        no="2"
                        filterable
                        :select-type="selectTypeNames.basic_data_Company"
                        :method-params="{ customer: true }"
                        :default-value="Number(billPayment.accountId) || ''"
                        style="width:170px;"
                        tag-name="chineseName"
                        disabled
                        @parentCallBack="
                          p => {
                            billPayment.accountId = p.value;
                            accountChange(p.value);
                          }
                        "
                      />
                      <div style="margin-left: 10px;display: flex; justify-content: space-between">
                        <el-checkbox
                          v-model="agentChecked"
                          no="3"
                          :disabled="!readonly && this.settlementAgentArray.length == 0"
                          @change="cbSettlementAgentChange"
                        >{{ $t("Payment.bySettlementAgent") }}</el-checkbox>
                        <cargo-advance-select
                          no="4"
                          filterable
                          :select-type="selectTypeNames.basic_data_Company"
                          :default-value="
                            Number(billPayment.settlementAgentId) === 0 ? '' : Number(billPayment.settlementAgentId)
                          "
                          :disabled="!agentChecked"
                          :cache="false"
                          tag-name="chineseName"
                          :static-options="settlementAgentArray"
                          style="margin-left: 10px"
                          @parentCallBack="
                            p => {
                              billPayment.settlementAgentId = p.value;
                              settlementAgentChange();
                            }
                          "
                        />
                      </div>
                    </div>
                  </el-form-item>
                  <div class="el-form-item-wrapper">
                    <el-form-item :label="$t('Partners.paymentType')">
                      <cargo-advance-select
                        no="paymentType"
                        filterable
                        :select-type="selectTypeNames.basic_data_PaymentType"
                        :default-value="billPayment.paymentType"
                        style="width:170px;"
                        tag-name="name"
                        @parentCallBack="
                          p => {
                            billPayment.paymentType = p.value;
                          }
                        "
                      />
                    </el-form-item>
                    <el-form-item v-if="!ifJc" required :label="$t('CargoMsg.Cargo_OurHeader')">
                      <cargo-advance-select
                        no="ourTitle"
                        :select-type="selectTypeNames.static_data_InvoiceTitle"
                        filterable
                        :cache="false"
                        :default-value="billPayment.ourTitle"
                        :static-options="ourInvoiceTitleArray"
                        @parentCallBack="ourTitleChangeEvent"
                      />
                    </el-form-item>
                  </div>
                  <el-form-item :label="$t('Payment.businessType')">
                    <el-checkbox-group v-model="jobTypes" no="5" disabled>
                      <el-checkbox label="SE">{{ $t("Payment.oceanExport") }}</el-checkbox>
                      <el-checkbox label="SI">{{ $t("Payment.oceanImport") }}</el-checkbox>
                      <el-checkbox label="AE">{{ $t("Payment.airExport") }}</el-checkbox>
                      <el-checkbox label="AI">{{ $t("Payment.airImport") }}</el-checkbox>
                      <el-checkbox label="RE">{{ $t("CargoMsg.Cargo_RailwayExport") }}</el-checkbox>
                      <el-checkbox label="RI">{{ $t("CargoMsg.Cargo_RailwayImport") }}</el-checkbox>
                      <el-checkbox label="IE">{{ $t("CargoMsg.Cargo_IntegratedJob") }}</el-checkbox>
                      <el-checkbox label="FBA">FBA</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <div class="el-form-item-wrapper">
                    <el-form-item
                      :label="singleRateView ? $t('Payment.currency') : $t('CargoMsg.Cargo_CurrencyOfPayment')"
                    >
                      <cargo-advance-select
                        no="6"
                        style="width: 115px"
                        filterable
                        :clearable="false"
                        :select-type="selectTypeNames.basic_data_Currency"
                        :default-value="billPayment.currency"
                        @parentCallBack="p => currencyChange(p.value, true)"
                      />
                    </el-form-item>
                    <el-form-item v-if="!billPayment.rateByCharge && ifHistoryPayment" :label="rateLabel">
                      <num-input
                        v-model="billPayment.rate"
                        no="7"
                        :min="0"
                        :max="999999999"
                        :precision="8"
                        :truncated-precision="exchangeRatePrecision"
                        style="width: 120px;"
                        @change="rateChange"
                      />
                    </el-form-item>
                    <el-form-item :label="$t('Payment.amount')" label-width="50px">
                      <el-input-number
                        v-model="billPayment.amount"
                        no="8"
                        :precision="2"
                        disabled
                        :controls="false"
                        style="width: 100px;"
                      />
                    </el-form-item>
                    <el-form-item
                      v-show="this.showWhtTax"
                      :label="$t('FinanceManage.charge_notWhtAmount')"
                      label-width="80px"
                    >
                      <el-input-number
                        v-model="billPayment.chargeNotWhtAmount"
                        no="8"
                        :precision="2"
                        disabled
                        :controls="false"
                        style="width: 100px;"
                      />
                    </el-form-item>
                  </div>
                  <div class="el-form-item-wrapper">
                    <el-form-item :label="$t('Payment.paymentPeriod')">
                      <el-date-picker
                        v-model="billPayment.deadline"
                        no="9"
                        type="date"
                        clearable
                        style="width: 170px;"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                      />
                    </el-form-item>
                    <el-form-item :label="$t('Payment.methodOfPayment')">
                      <el-select v-model="billPayment.payType" no="10" style="width: 170px">
                        <el-option
                          v-for="(item, index) in receiveTypes"
                          :key="index"
                          :label="$store.getters.language === 'zh' ? item.chineseName : item.englishName"
                          :value="Number(item.code)"
                        />
                      </el-select>
                    </el-form-item>
                  </div>
                  <div class="el-form-item-wrapper">
                    <el-form-item :label="$t('Payment.invoiceHeader')">
                      <cargo-advance-select
                        v-if="showInvoiceTitle"
                        no="11"
                        :allow-create="true"
                        :select-type="selectTypeNames.static_data_Title"
                        filterable
                        :cache="false"
                        :default-value="billPayment.invoiceTitle"
                        :static-options="titleArray"
                        tag-name="title"
                        tag-value="title"
                        style="width:170px;"
                        @parentCallBack="invoiceTitleChange"
                      />
                    </el-form-item>
                    <el-form-item class="custom-textarea">
                      <template slot="label">
                        <span v-if="isSpecialExpensePaymentType" style="color: red;">*</span>
                        {{ $t("Payment.replaceInvoiceRemark") }}
                      </template>
                      <el-input v-model="billPayment.replaceInvoiceRemark" style="width: 170px" />
                    </el-form-item>
                  </div>
                  <div class="el-form-item-wrapper">
                    <el-form-item :label="$t('Payment.bankOfDeposit')">
                      <cargo-advance-select
                        no="13"
                        filterable
                        :select-type="selectTypeNames.static_data_TitleBank"
                        :default-value="billPayment.buyerBank"
                        :cache="false"
                        :static-options="titleBankArray"
                        tag-value="bank"
                        tag-name="bank"
                        :allow-create="true"
                        style="width:170px;"
                        @parentCallBack="titleBankChange"
                      />
                    </el-form-item>
                    <el-form-item :label="$t('Payment.bankAccount')">
                      <el-input v-model="billPayment.buyerBankAccount" no="12" style="width:170px;" />
                    </el-form-item>
                  </div>
                  <div class="el-form-item-wrapper">
                    <el-form-item :label="$t('Payment.applicant')">
                      <cargo-advance-select
                        no="15"
                        :select-type="selectTypeNames.basic_data_User"
                        :default-value="Number(billPayment.inputBy) || ''"
                        style="width:170px;"
                        disabled
                      />
                    </el-form-item>
                    <el-form-item :label="$t('Payment.dateOfApplication')">
                      <el-date-picker
                        v-model="billPayment.inputDate"
                        no="14"
                        type="date"
                        :clearable="false"
                        style="width:170px;"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                      />
                    </el-form-item>
                  </div>
                  <template v-if="showEnterpriseWechatFields">
                    <div
                      v-for="(row, rowIndex) in enterpriseWechatSelectFieldRows"
                      :key="`enterprise-wechat-select-row-${rowIndex}`"
                      class="el-form-item-wrapper"
                    >
                      <el-form-item
                        v-for="field in row"
                        :key="field.prop"
                        :label="getEnterpriseWechatLabel(field)"
                        label-width="90px"
                      >
                        <!-- 企业微信扩展字段：用 type 区分渲染 input/select -->
                        <el-input
                          v-if="field.type === 'text'"
                          v-model="billPayment[field.prop]"
                          :disabled="!!field.disabled"
                          :style="{ width: '170px'}"
                        />
                        <cargo-advance-select
                          v-else
                          :default-value="billPayment[field.prop]"
                          :static-options="field.options"
                          filterable
                          :filter-type="'global'"
                          :filter-tag-names="field.prop === 'waterNotifier' ? ['label', 'userName', 'chineseName', 'englishName'] : ['label']"
                          :cache="false"
                          tag-name="label"
                          tag-value="value"
                          :disabled="!!field.disabled"
                          :style="{ width: '170px'}"
                          @parentCallBack="p => handleEnterpriseWechatSelectCallback(field, p)"
                        />
                      </el-form-item>
                    </div>
                  </template>
                  <div class="el-form-item-wrapper">
                    <el-form-item label="" style="margin-bottom: 0 !important;">
                      <el-checkbox v-model="billPayment.syncInvoiceAttachment" no="syncInvoiceAttachment">
                        {{ $t('CargoMsg.Cargo_SyncInvoiceAttachment') }}
                      </el-checkbox>
                    </el-form-item>
                  </div>
                  <div v-if="toExoSystemYGSH">
                    <el-form-item :label="$t('CargoMsg.Cargo_PaymentBranch')">
                      <el-select v-model="billPayment.settleDepartmentPrefix" no="16" style="width: 170px">
                        <el-option
                          v-for="(item, index) in paymentBranchType"
                          :key="index"
                          :label="$store.getters.language === 'zh' ? item.chineseName : item.englishName"
                          :value="item.code"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_Remarks2')">
                      <el-select v-model="billPayment.recordType" no="17" style="width: 170px">
                        <el-option
                          v-for="(item, index) in sendRemarkTypes"
                          :key="index"
                          :label="$store.getters.language === 'zh' ? item.chineseName : item.englishName"
                          :value="$store.getters.language === 'zh' ? item.chineseName : item.englishName"
                        />
                      </el-select>
                    </el-form-item>
                  </div>
                  <div class="el-form-item-wrapper">
                    <el-form-item :label="$t('Payment.totalCurrency')">
                      <div style="width: 170px;">
                        <span>{{ billPayment.currencyAmount }}</span>
                      </div>
                    </el-form-item>
                    <el-form-item v-show="openSapConfig" :label="$t('Payment.settleDepartmentPrefix')">
                      <cargo-advance-select
                        no="18"
                        filterable
                        :select-type="selectTypeNames.basic_data_Department"
                        :default-value="billPayment.settleDepartmentPrefix || ''"
                        :cache="false"
                        :static-options="departmentArray"
                        style="width:170px;"
                        tag-name="chineseName"
                        tag-value="jobNoPrefix"
                        @parentCallBack="settleDepartmentPrefixChange"
                      />
                    </el-form-item>
                  </div>
                </div>
                <div style="width: 290px;">
                  <div class="el-form-item-wrapper">
                    <el-form-item label-width="0">
                      <span style="font-weight: bold;color:darkred;font-size: 14px;">{{
                        $t("Payment.couldNotSearhWriteOffJobFromThisWindow")
                      }}</span>
                    </el-form-item>
                  </div>
                  <div v-if="toExoSystemYGSH" class="el-form-item-wrapper">
                    <el-form-item
                      :label="$t('CargoMsg.Cargo_ApplicationDetails')"
                      label-width="100px"
                      class="custom-textarea"
                    >
                      <el-input
                        v-model="billPayment.sendRemark"
                        no="19"
                        type="textarea"
                        :rows="5"
                        style="width:290px;"
                      />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_Remarks2')" label-width="100px" class="custom-textarea">
                      <el-input v-model="billPayment.remark" no="20" type="textarea" :rows="5" style="width:290px;" />
                    </el-form-item>
                  </div>
                  <div v-else class="el-form-item-wrapper">
                    <el-form-item :label="$t('Payment.invoiceNumber')" label-width="100px" class="custom-textarea">
                      <el-input v-model="billPayment.invoiceNumber" type="textarea" :rows="6" style="width:290px;" />
                    </el-form-item>
                    <el-form-item :label="$t('Payment.remarks')" label-width="100px" class="custom-textarea">
                      <el-input v-model="billPayment.remark" no="21" type="textarea" :rows="12" style="width:290px;" />
                    </el-form-item>
                    <el-form-item
                      :label="$t('CargoMsg.Cargo_PaymentReason')"
                      label-width="100px"
                      class="custom-textarea"
                    >
                      <el-input
                        v-model="billPayment.paymentInstructions"
                        no="paymentInstructions"
                        type="textarea"
                        :rows="5"
                        style="width:290px;"
                      />
                    </el-form-item>
                  </div>
                </div>
                <div
                  v-if="!ifJc && customFields && customFields.length > 0"
                  style="width: 340px; height:400px; margin-left: 52px"
                >
                  <el-form-item
                    v-for="(customField, index) in customFields"
                    :key="index"
                    :label="isZh ? customField.chineseName : customField.englishName"
                    style="margin-left: 15px;margin-right: 0"
                    label-width="120px"
                  >
                    <el-input
                      v-if="customField.widgetType === SystemConstants.WIDGET_TYPE_TEXTBOX.code"
                      v-model="
                        billPayment[SystemConstants.CUSTOM_FIELDS_PAYMENT_REQUEST_MAP.get(customField.fieldCode)]
                      "
                      style="width:205px;"
                    />
                    <cargo-advance-select
                      v-if="customField.widgetType === SystemConstants.WIDGET_TYPE_DROPDOWN.code"
                      :default-value="
                        billPayment[SystemConstants.CUSTOM_FIELDS_PAYMENT_REQUEST_MAP.get(customField.fieldCode)]
                      "
                      :static-options="customField.enums"
                      filterable
                      :cache="false"
                      tag-name="tagName"
                      tag-value="tagValue"
                      style="width:205px;"
                      @parentCallBack="
                        p => {
                          billPayment[SystemConstants.CUSTOM_FIELDS_PAYMENT_REQUEST_MAP.get(customField.fieldCode)] = p
                            ? p.tagValue
                            : '';
                        }
                      "
                    />
                  </el-form-item>
                </div>
              </div>
            </el-form>
            <div v-if="!singleRateView && (readonly || btnSaveEnable)" style="padding-bottom: 10px">
              <el-radio-group
                v-model="reconciliationType"
                no="reconciliationMode"
                @change="reconciliationTypeChangeHandler"
              >
                <el-radio no="viewedByJob" label="job">{{ $t("CargoMsg.Cargo_ViewedByJob") }}</el-radio>
                <el-radio no="viewedByFee" label="charge" style="margin-right:10px">{{
                  $t("CargoMsg.Cargo_ViewedByFee")
                }}</el-radio>
              </el-radio-group>
            </div>
            <cargo-ag-grid
              config-module="190805"
              :grid-params.sync="gridParams"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="rowData"
              style="width:100%;height:100%;flex-grow: 1"
            />
            <div v-if="!singleRateView" style="display: flex; margin-top:10px; justify-content: space-between;">
              <div style="display: flex;flex-wrap: wrap;justify-content: flex-start; align-items: center;">
                <el-form
                  :inline="true"
                  label-width="40px"
                  label-position="right"
                  style="display: flex;justify-content: space-between; align-items: center;"
                >
                  <span
                    v-if="billPayment.currency1 && !ifHistoryPayment && !billPayment.rateByCharge"
                    style="vertical-align: middle"
                  >{{ $t("Invoice.invoice_currency") }} </span>&nbsp;&nbsp;<span
                    v-if="billPayment.currency1 && !ifHistoryPayment && !billPayment.rateByCharge"
                    style="font-weight: bold;vertical-align: middle"
                  >{{ billPayment.currency1 }}<i class="el-icon-right" />{{ billPayment.currency }}</span>
                  <el-form-item
                    v-if="billPayment.currency1 && !ifHistoryPayment && !billPayment.rateByCharge"
                    :label="$t('Invoice.invoice_exchangeRate')"
                    :label-width="$selectByLang('', '95px')"
                    style="margin-bottom: 0 !important;margin-right: 5px"
                  >
                    <num-input
                      v-model="billPayment.rate1"
                      :disabled="billPayment.currency1 === billPayment.currency || billPayment.payByBillingRate"
                      no="rate1"
                      :precision="8"
                      :truncated-precision="rate1Precision"
                      style="width: 95px;"
                      @change="
                        p => {
                          currencyRateChanged(p, 'currency1');
                        }
                      "
                    />
                  </el-form-item>
                  <span
                    v-if="billPayment.currency2 && !ifHistoryPayment && !billPayment.rateByCharge"
                    style="vertical-align: middle"
                  >{{ $t("Invoice.invoice_currency") }} </span>&nbsp;&nbsp;<span
                    v-if="billPayment.currency2 && !ifHistoryPayment && !billPayment.rateByCharge"
                    style="font-weight: bold;vertical-align: middle"
                  >{{ billPayment.currency2 }}<i class="el-icon-right" />{{ billPayment.currency }}</span>
                  <el-form-item
                    v-if="billPayment.currency2 && !ifHistoryPayment && !billPayment.rateByCharge"
                    :label="$t('Invoice.invoice_exchangeRate')"
                    :label-width="$selectByLang('', '95px')"
                    style="margin-bottom: 0 !important;margin-right: 5px"
                  >
                    <num-input
                      v-model="billPayment.rate2"
                      :disabled="billPayment.currency2 === billPayment.currency || billPayment.payByBillingRate"
                      no="rate2"
                      :precision="8"
                      :truncated-precision="rate2Precision"
                      style="width: 95px;"
                      @change="
                        p => {
                          currencyRateChanged(p, 'currency2');
                        }
                      "
                    />
                  </el-form-item>
                  <span
                    v-if="billPayment.currency3 && !ifHistoryPayment && !billPayment.rateByCharge"
                    style="vertical-align: middle"
                  >{{ $t("Invoice.invoice_currency") }} </span>&nbsp;&nbsp;<span
                    v-if="billPayment.currency3 && !ifHistoryPayment && !billPayment.rateByCharge"
                    style="font-weight: bold;vertical-align: middle"
                  >{{ billPayment.currency3 }}<i class="el-icon-right" />{{ billPayment.currency }}</span>
                  <el-form-item
                    v-if="billPayment.currency3 && !ifHistoryPayment && !billPayment.rateByCharge"
                    :label="$t('Invoice.invoice_exchangeRate')"
                    :label-width="$selectByLang('', '95px')"
                    style="margin-bottom: 0 !important;margin-right: 5px"
                  >
                    <num-input
                      v-model="billPayment.rate3"
                      :disabled="billPayment.currency3 === billPayment.currency || billPayment.payByBillingRate"
                      no="rate3"
                      :precision="8"
                      :truncated-precision="rate3Precision"
                      style="width: 95px;"
                      @change="
                        p => {
                          currencyRateChanged(p, 'currency3');
                        }
                      "
                    />
                  </el-form-item>
                  <el-form-item label="" style="margin-bottom: 0 !important;margin-right: 5px">
                    <el-checkbox
                      v-if="!ifHistoryPayment"
                      v-model="billPayment.payByBillingRate"
                      :disabled="!canUseBillingRate"
                      no="payByBillingRate"
                      @change="payByBillingRateChanged"
                    >{{ $t("CargoMsg.Cargo_PayByBillingRate") }}</el-checkbox>
                  </el-form-item>
                  <el-form-item label="" style="margin-bottom: 0 !important;">
                    <el-checkbox
                      v-if="showRateByCharge"
                      v-model="billPayment.rateByCharge"
                      no="rateByCharge"
                      @change="rateByChargeChanged"
                    >{{ $t("WriteOff.rateByCharge") + $t("CargoMsg.Cargo_Create") }}</el-checkbox>
                  </el-form-item>
                </el-form>
              </div>
            </div>
            <div v-if="!singleRateView" style="display: flex; margin-top:10px; justify-content: space-between;">
              <div style="display: flex;flex-wrap: wrap;justify-content: flex-start; align-items: center;">
                <span>{{ $t("Payment.total") }}</span>
                <charge-currency-total-group
                  :key="1"
                  ar-field="chargeReceivable"
                  :data-field="reconciliationType === 'charge' ? 'chargeAmount' : 'chargeAmounts'"
                  currency-field="chargeCurrency"
                  rate-field="chargeRate"
                  arap-order="ar,ap"
                  type="auto"
                  source="billPaymentDialogGroup"
                  :data-provider="rowData"
                />
              </div>
            </div>
            <div v-if="singleRateView" style="display: flex; margin-top:10px; justify-content: space-between;">
              <div style="justify-content: flex-start">
                <el-checkbox
                  v-if="showRateByCharge"
                  v-model="billPayment.rateByCharge"
                  no="rateByCharge"
                  @change="refreshAmount"
                >{{ $t("WriteOff.rateByCharge") + $t("CargoMsg.Cargo_Create") }}</el-checkbox>
              </div>
              <div style="justify-content: flex-end;">
                <span>{{ $t("Payment.total") }}</span>
                <charge-currency-total-group
                  :key="1"
                  ar-field="chargeReceivable"
                  data-field="chargeAmount"
                  currency-field="chargeCurrency"
                  rate-field="chargeRate"
                  arap-order="ar,ap"
                  type="auto"
                  source="billPaymentDialogGroup"
                  :data-provider="rowData"
                />
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane
            v-if="billPayment.uuid"
            :label="$t('CargoMsg.Cargo_FileHistory')"
            name="fileHistory"
            :lazy="true"
            style="height: 509px;"
          >
            <file-history
              :bill-payment-uuid="billPayment.uuid"
              :uuid="billPayment.uuid"
              :state="billPayment.state"
              module-name="billPayment"
              :input-by="$store.getters.userId"
              grid-height="460px"
            />
          </el-tab-pane>
          <el-tab-pane
            v-if="billPayment.uuid"
            :label="$t('CargoMsg.Cargo_ApprovalHistory')"
            name="approvalList"
            :lazy="true"
            style="height: 503px;"
          >
            <approval-history
              :bill-payment-uuid="billPayment.uuid"
              :approve-history-platform="true"
              style="width: 100%;"
              grid-height="503px"
            />
          </el-tab-pane>
        </el-tabs>
      </div>
      <div slot="footer" slot-scope="">
        <span
          v-if="billPayment.state == 0 && step === 'step2' && mode === 'edit'"
          style="position: absolute; left: 20px;"
        >
          <el-button
            v-if="activeTabName === 'applicationForm' && billPayment.uuid && billPayment.state == 0"
            no="22"
            type="primary"
            @click="addCharge"
          >{{ $t("Payment.addCharge") }}</el-button>
          <el-button
            v-if="activeTabName === 'applicationForm' && billPayment.state == 0"
            no="23"
            type="primary"
            @click="removeCharge"
          >{{ $t("Payment.removeCharge") }}</el-button>
          <el-button
            v-if="activeTabName === 'applicationForm' && billPayment.state === 0"
            type="primary"
            @click="toSplitCharge"
          >{{ $t("Invoice.invoice_sp31") }}</el-button>
        </span>
        <span style="padding-right: 10px;">
          <el-button
            v-if="activeTabName === 'applicationForm' && !billPayment.uuid && step === 'step2' && mode === 'edit'"
            no="24"
            type="primary"
            @click="toPreStep"
          >{{ $t("Payment.back") }}</el-button>
          <el-button
            v-if="activeTabName === 'applicationForm' && billPayment.uuid"
            no="25"
            type="primary"
            @click="doPrint"
          >{{ $t("Payment.print") }}</el-button>
          <el-button
            v-if="billPayment.uuid"
            v-show="$checkPermission(['button_fmBillPaymentByJob_billPaymentHandle'])"
            type="primary"
            @click="processPaymentRequest"
          >
            {{ $t("Payment.processPaymentRequest") }}
          </el-button>
          <el-button
            v-if="activeTabName === 'applicationForm' && billPayment.uuid && billPayment.state == 0"
            no="26"
            type="primary"
            :loading="commitSubmitting"
            :disabled="commitSubmitting"
            @click="doCommitPre"
          >{{ $t("Payment.submit") }}</el-button>
          <el-button v-if="$checkPermission(['button_fmBillPaymentByJob_invoicePoolHandle'])" type="primary" :disabled="readonly || btnSaveEnable" @click="showInvoicePoolDialog">
            {{ $t('CargoMsg.Cargo_InvoicePoolReceiving') }}
          </el-button>
          <el-button type="primary" :disabled="readonly || btnSaveEnable" no="27" @click="doSavePre">{{
            $t("Payment.save")
          }}</el-button>
          <el-button no="28" @click="cancel">{{ $t("Payment.cancel") }}</el-button>
        </span>
      </div>
      <!--打印模板-->
      <cargo-template-selector-dialog
        :visible.sync="templateSelectorDialog.visible"
        :ctx="templateSelectorDialog.cxt"
        :category="templateSelectorDialog.category"
        :data="templateSelectorDialog.data"
        @selectedTemplate="updatePrintField"
      />
      <!--加入费用-->
      <join-charge-dialog
        v-if="joinChargeDialog.visible"
        :visible.sync="joinChargeDialog.visible"
        search-item-module="5043"
        :default-conditions="joinChargeDialog.addChargeCondition"
        charge-state-param="BillPaymentChargeState"
        @addChargeCallBackEvent="addChargeCallBack"
      />
      <!-- 发票池弹窗 -->
      <invoice-pool-dialog
        v-if="invoicePoolDialog.visible"
        :visible.sync="invoicePoolDialog.visible"
        :seller-tax-name-default-value="invoicePoolDialog.sellerTaxNameDefaultValue"
        :selected-entities="invoicePoolDialog.selectedEntities"
        :make-invoice-method="invoicePoolDialog.makeInvoiceMethod"
        :source="invoicePoolDialog.source"
        :operation="invoicePoolDialog.operation"
        :callback="invoicePoolCallBack"
      />
      <!-- 付款申请审批流 -->
      <bill-payment-work-flow-apply-dialog
        v-if="workFlowApplyDialog.visible"
        :visible.sync="workFlowApplyDialog.visible"
        :bill-payment="billPayment"
        :show-wht="showWht"
        :title="$t('CargoMsg.Cargo_SubmitAPaymentRequestForApproval')"
        type="apply"
        @close="workFlowApplyDialog.visible = false"
        @closeAndRefresh="applyCloseAndRefresh"
      />
    </cargo-dialog>
    <!-- 多条业务，配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :lob="batchCheckingWindow.lob"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :bill-payments="batchCheckingWindow.billPayments"
      :call-back="batchCheckingWindow.callBack"
    />
    <!--  费用拆分弹窗页  -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="splitChargeDialog.show"
      :title="$t('CargoMsg.Cargo_Sp31')"
      width="760px"
      class="make-invoice-step-two-split-charge-dialog"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <el-form :inline="true" :model="splitChargeDialog.splitChargeForm" label-width="70px" label-position="right">
        <div class="el-form-item-wrapper">
          <el-form-item :label="$t('CargoMsg.Cargo_OriginalExpenseP')">
            <span>{{ splitChargeDialog.charge.chargeName }}</span>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CurrencyP')">
            <span>{{ splitChargeDialog.charge.currency }}</span>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_TaxIncludedPriceP')">
            <span>{{ splitChargeDialog.charge.amount }}</span>
          </el-form-item>
        </div>
        <div class="el-form-item-wrapper">
          <el-form-item :label="$t('CargoMsg.Cargo_SplitExpenseP')">
            <span>{{ splitChargeDialog.splitCharge.chargeName }}</span>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CurrencyP')">
            <span>{{ splitChargeDialog.splitCharge.currency }}</span>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_TaxIncludedPriceP')" class="custom-form-item-w">
            <el-input-number
              v-model="splitChargeDialog.splitCharge.amount"
              no="amount"
              :precision="2"
              controls-position="right"
              :controls="false"
              @change="amountChangeHandler"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_TaxExcludedPriceP')" class="custom-form-item-w">
            <el-input-number
              v-model="splitChargeDialog.splitCharge.excludingTaxAmount"
              no="excludingTaxAmount"
              :precision="2"
              :min="-99999999"
              :max="99999999"
              controls-position="right"
              :disabled="true"
            />
          </el-form-item>
        </div>
        <div class="el-form-item-wrapper">
          <el-form-item label=" " />
          <el-form-item label=" " />
          <el-form-item :label="$t('CargoMsg.Cargo_TaxAmountP')" class="custom-form-item-w">
            <el-input-number
              v-model="splitChargeDialog.splitCharge.taxAmount"
              no="taxAmount"
              :precision="2"
              :min="-99999999"
              :max="99999999"
              controls-position="right"
              :disabled="true"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_TaxRateP')" class="custom-form-item-w">
            <el-input-number
              v-model="splitChargeDialog.splitCharge.taxRate"
              no="taxRate"
              :precision="2"
              :min="-99999999"
              :max="99999999"
              controls-position="right"
              :disabled="true"
            />
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer">
        <span style="position: absolute; left: 0; padding-left: 10px;">
          <el-checkbox
            v-model="splitChargeDialog.onlyChangeQuantity"
            no="onlyChangeQuantity"
            @change="onlyChangeQuantityChangeHandler"
          >{{ $t("Invoice.invoice_SplitChargeOnlyChangeQuantity") }}</el-checkbox>
        </span>
        <el-button no="ok" type="primary" :disabled="splitChargeDialog.btnSplitEnable" @click="doSplitCharge">{{
          $t("common.btn.ok")
        }}</el-button>
        <el-button no="cancel" @click="splitChargeDialog.show = false">{{ $t("common.btn.cancel") }}</el-button>
      </div>
    </el-dialog>

    <!--特殊审批-->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="specialDialog.visible"
      :title="$t('CargoMsg.Cargo_SpecialApproval2')"
      width="580px"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="dialog-content">
        <el-form ref="specialForm" :inline="true" :model="specialDialog" label-width="100px" label-position="right">
          <el-form-item :label="$t('CargoMsg.Application_Item')" style="margin-top: 10px">
            <cargo-advance-select
              :default-value="specialDialog.applyMatter"
              :static-options="[{ code: '专项超过毛利2倍申请' }]"
              filterable
              tag-name="code"
              tag-value="code"
              :disabled="true"
              :cache="false"
              style="width:400px;"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Application_Content')" style="margin-top: 20px">
            <el-input v-model="specialDialog.applyContent" type="textarea" :rows="4" style="width:400px;" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Application_Reason')" style="margin-top: 20px">
            <el-input v-model="specialDialog.applyReason" type="textarea" :rows="4" style="width:400px;" />
          </el-form-item>
          <el-form-item :label="$t('Pricing.Attachment')" style="margin-top: 20px">
            <div class="upload-file-row" style="margin-left: 40px">
              <template v-if="hasUploadedSpecialFile()">
                <span class="upload-file-name">{{ getSpecialUploadedFileName() }}</span>
                <el-button
                  class="upload-file-remove"
                  type="text"
                  icon="el-icon-close"
                  @click="handleRemoveSpecialUpload"
                />
              </template>
              <el-button v-else type="primary" @click="cloudFile.visible = true">
                {{ $t("CargoMsg.Action_AddAttachment") }}
              </el-button>
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" style="text-align: center;margin-top: 20px">
          <el-button no="ok" type="primary" @click="doApproval">{{ $t("common.btn.ok") }}</el-button>
          <el-button no="cancel" @click="specialDialog.visible = false">{{ $t("common.btn.cancel") }}</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 云文件上传对话框 -->
    <cargo-cloud-file-upload
      :visible.sync="cloudFile.visible"
      :job="cloudFile.job"
      :lob="cloudFile.lob"
      @uploadDone="
        data => {
          uploadSuccess(data);
        }
      "
    />
  </div>
</template>

<script>
import { getCustomFieldList } from '@/api/sysManage/baseConfig/customFieldDisplayConfiguration'
import { ApiCacheManage } from '@/utils/commonUtil'
import { getInvoiceTitlesByOffice } from '@/api/sysManage/officeInvoiceTitle'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { BillPayment } from '@/class/model/act/BillPayment'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { formatNumberToThousands } from '@/utils'
import joinChargeDialog from '@/components/Cargo/Act/joinChargeDialog'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import URL from '@/api/urlTranslator'
import {
  createBillPayment,
  getChargeBillingMultiCurrencyInfo,
  queryBillPaymentDetail,
  queryChargeOfBillPayment,
  queryJobOfBillPayment,
  updateBillPayment,
  updateBillPaymentState,
  uploadHasPrint,
  checkBillPaymentJobSettleFunc,
  initiateSpecialApprovalFunc,
  checkLackInvoiceFlagFunc
} from '@/api/clearing/billPayment'
import { normalizeBillPaymentJobSettleCheck } from '../BillPaymentByJob/billPaymentJobSettleCheck'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import { getSettlementAgentsByCmpIdx } from '@/api/company'
import { getCacheListByKey, getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { allTitleBanksByCmpIdx, upsertPartnerTitleBank } from '@/api/partner/titleBank'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import { getGridSelected } from '@/utils/agGrid'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { cache, cacheName } from '@/utils/cacheManager'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import chargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import { RMBBigTransForm } from '@/class/cargo/model/utils/RMBBigTransForm'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import DateUtils from '@/utils/dateUtils'
import fileHistory from '@/views/cargo/v0/Clearing/components/BillPayment/fileHistory'
import moment from 'moment'
import { getTitleByCmpIdxList, queryTitleByCpmIdx } from '@/api/partner/title'
import approvalHistory from '@/views/cargo/v0/Clearing/components/BillPayment/siRui/approvalHistory'
import { matchView, refreshView } from '@/store/modules/tagsView'
import { getJumpFinaceOrBusinessAttrs } from '@/components/Cargo/grid/routerAndPrintHelp'
import BillPaymentWorkFlowApplyDialog from '@/components/Cargo/Common/Wrokflow/billPaymentApplyDialog'
import lang from '@/lang'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'
import NumInput from '@/components/Cargo/Common/NumInput'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow.vue'
import CheckingWindow from '@/components/Cargo/Job/CheckingManager/CheckingWindow.vue'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { saveSplitCharge } from '@/api/clearing/invoice'
import enterpriseWechatMixin from '@/views/cargo/v0/Clearing/components/BillPaymentByJob/enterpriseWechatMixin'
import { autoBillPaymentWriteOffFunc } from '@/api/clearing/actualAmount'
import { Company } from '@/class/model/mdm/Company'
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload.vue'
import { Project } from '@/class/model/pm/Project'
import { getChargeItemsByItemIds } from '@/api/payservice'
import { loadChargeByUuids } from '@/api/clearing/billingNative'
import { applyLatestCharges, buildChargeAssociationLabel, buildInvoicePoolOpenState, collectChargeUuids, isChargeAssociatedWithInvoice } from './invoicePoolReceiving'
import InvoicePoolDialog from '@/views/cargo/v0/Clearing/components/invoicePool/invoicePoolDialog'

export default {
  name: 'BillPaymentDialog',
  components: {
    CheckingWindow,
    BatchCheckingWindow,
    CargoDialog,
    cargoTemplateSelectorDialog,
    joinChargeDialog,
    cargoAdvanceSelect,
    chargeCurrencyTotalGroup,
    fileHistory,
    approvalHistory,
    NumInput,
    cargoCloudFileUpload,
    InvoicePoolDialog
  },
  mixins: [enterpriseWechatMixin],
  props: {
    visible: { type: Boolean, required: true },
    title: { type: String, required: false, default: lang.t('Clearing.ViewPaymentRequestForm') },
    billPaymentUuid: { type: String, required: false, default: '' }, // 付款申请单Uuid
    isDirectPayment: { type: Boolean, required: false, default: false }, // 是否直达
    openSapConfig: { type: Boolean, required: false, default: false },
    toExoSystemYGSH: { type: Boolean, required: false, default: false }, // 阳光速航
    createSubmit: { type: Boolean, default: false }, // 创建完直接提交
    step: { type: String, default: 'step1' },
    source: { type: String, default: '' },
    showWht: { type: Boolean, default: false }, // 是否显示去税WHT金额
    mode: { type: String, default: 'edit' }, // 是否查看付款申请
    job: { type: Object, required: false, default: null }, // 国内外账单点击 申请付款 按钮使用，其它是null
    viewSource: { type: String, default: '' }, // 页面请求发起方
    location: { type: String, required: false }
  },
  data() {
    return {
      SystemConstants,
      customFields: [],
      toExoSystemHC: false,
      getInvoiceTitlesByOfficeCache: new ApiCacheManage(getInvoiceTitlesByOffice), // getInvoiceTitlesByOffice缓存管理
      ourInvoiceTitleArray: [], // 我方发票抬头选项
      defaultTitle: '',
      defaultTitleUuid: '',
      existDistinctTitle: false,
      showInvoiceTitle: true,
      fullscreen: false,
      reconciliationType: 'charge',
      loading: false,
      minSize: false,
      commitSubmitting: false,
      curBillPaymentUuid: '',
      billPayment: {},
      originalCurrency: '', // 付款申请原始币种
      invoiceCurrencyRate: {}, // 发票上币种汇率
      currencyRateMap: {},
      billingList: [],
      billCurrencyList: [],
      canUseBillingRate: false,
      selectTypeNames: TYPE_NAMES,
      URL,
      agentChecked: 0, // 是否选中使用结算代理 1是 0否
      jobTypes: [],
      titleArray: [],
      settlementAgentArray: [], // 结算代理数据源
      titleBankArray: [], // 开户银行数据源
      allTitleBankArray: [], // 全量开户银行数据源（用于按开票抬头过滤）
      otherCurrencyArray: [], // 费用列表中与付款申请单币种不同的费用币种集合
      receiveTypes: ClearingConstants.AMOUNT_RECEIVE_TYPES, // 收付方式源
      sendRemarkTypes: SystemConstants.SEND_REMARK_TYPES, // 备案类型
      paymentBranchType: SystemConstants.PAYMENT_BRANCH_TYPE, // 支付分公司
      rateLabel: this.$t('Payment.exchangeRate'), // 汇率label
      gridOptions: {
        rowSelection: 'multiple',
        defaultColDef: {
          filter: false
        },
        // 行背景色设置
        getRowStyle: function(params) {
          const rowStyle = {}
          if (params.data.ifDirty) {
            Object.assign(rowStyle, { background: '#FF0000' })
            return rowStyle
          }
        }
      },
      gridParams: {},
      gridApi: {},
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      pagination: {
        pageNum: 1,
        total: 0,
        pageSize: 5000
      },
      stateText: '', // 付款申请单状态
      templateSelectorDialog: {
        // 模板选择弹窗
        visible: false,
        cxt: null,
        category: 'BILLPAYMENT',
        data: {
          BILLPAYMENT_UUID: '',
          BILL_PAYMENT_UUID: ''
        }
      },
      joinChargeDialog: {
        // 加入费用弹窗
        visible: false,
        addChargeCondition: {
          // 点击加入费用按钮时传递的参数
          exceptKeys: [],
          hasBillPayment: -1,
          hasBilling: -1,
          oversea: -1,
          accountId: 0,
          viewSource: 'BillPaymentDetail_AddCharge' // 页面请求发起方
        }
      },
      invoicePoolDialog: {
        visible: false,
        sellerTaxNameDefaultValue: '',
        selectedEntities: [],
        source: 'invoice',
        operation: 'collection',
        makeInvoiceMethod: 1
      },
      departmentArray: [], // 付款申请结算公司数据源
      enterpriseWechatWaterNotifierOptions: [],
      deadlineConfig: -1,
      buyerBankUuid: '', // 开户银行虚拟字段，解决CARGO-12143问题
      btnSaveEnable: false,
      activeTabName: 'applicationForm', // 当前展示页签
      showGrossProfit: false, // 是否显示毛利率,默认显示【1:显示，0:不显示】
      isSpecialExpenseEntryFunction: false,
      specialDialog: {
        visible: false,
        billPaymentUuid: '',
        applyMatter: '专项超过毛利2倍申请',
        applyContent: '',
        applyReason: '',
        fileList: []
      },
      cloudFile: {
        visible: false,
        job: new Project(),
        lob: 'allLob'
      },
      workFlowApplyDialog: {
        visible: false
      },
      rateByCharge: false, // 按费用汇率创建
      batchCheckingWindow: {
        lob: SystemConstants.SE.code,
        visible: false,
        jobs: [],
        checkNode: 0,
        callBack: null,
        callBack2: null,
        newJob: null,
        billPayments: []
      },
      splitChargeDialog: {
        show: false,
        charge: {}, // 要拆分的费用
        chargeOrigin: {},
        splitCharge: {
          chargeName: '', // 费用名称
          currency: '', // 币种
          amount: 0.0, // 含税价
          taxRate: 0.0, // 税率
          taxAmount: 0.0, // 税额
          excludingTaxAmount: 0.0, // 不含税额
          quantity: 1, // 数量
          billingAmount: 0.0, // 对帐金额
          remarks: '' // 备注
        }, // 拆分的费用
        splitChargeForm: {},
        btnSplitEnable: false,
        onlyChangeQuantity: true // 拆分后“单价”不变，“数量”更新
      }
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    isSpecialExpensePaymentType() {
      if (
        !this.billPayment ||
        this.billPayment.paymentType === undefined ||
        this.billPayment.paymentType === null ||
        this.billPayment.paymentType === ''
      ) {
        return false
      }
      const typeName = ColumnUtils.resolveColumnLabel(
        TYPE_NAMES.basic_data_PaymentType,
        'code',
        this.billPayment.paymentType,
        'name'
      )
      return typeName === this.$t('CargoMsg.Cargo_SpecialExpenseApplication')
    },
    showWhtTax() {
      return this.showWht && this.$store.getters.currentOffice.whtTaxMode
      // return true
    },
    readonly() {
      // 付款申请单是否可编辑
      return (
        this.billPayment && !!this.billPayment.uuid && this.billPayment.state !== '' && this.billPayment.state !== 0
      )
    },
    // REQ-0033：企微字段配置由后端清洗下发（titles/options/required/optionsSource），mixin 持有 enterpriseWechatFormFields
    enterpriseWechatFields() {
      return Array.isArray(this.enterpriseWechatFormFields) ? this.enterpriseWechatFormFields : []
    },
    // 取数触发键：付款类型 × 当前公司（右上角）任一变化即重取（保留 REQ-0027 切公司/切类型联动语义）
    wechatFormConfigTrigger() {
      const paymentType = this.billPayment && this.billPayment.paymentType
      const officeCode = (this.$store.getters.currentOffice || {}).code
      return `${paymentType === undefined || paymentType === null ? '' : paymentType}|${officeCode || ''}`
    },
    enterpriseWechatSelectFieldRows() {
      // hidden 字段（如后端未下发数据的所在部门）不参与渲染
      const selectFields = this.enterpriseWechatFields.filter(field => field && !field.hidden)
      const rows = []
      for (let i = 0; i < selectFields.length; i += 2) {
        rows.push(selectFields.slice(i, i + 2))
      }
      return rows
    },
    showEnterpriseWechatFields() {
      return Array.isArray(this.enterpriseWechatFormFields) && this.enterpriseWechatFormFields.length > 0
    },
    // titleArray() { // 抬头下拉数据源
    //   const distinctTitleSet = new Set()
    //   const titles = []
    //   this.rowData.forEach(charge => {
    //     if (charge.chargeInvoiceTitle) {
    //       if (!distinctTitleSet.has(charge.chargeInvoiceTitle)) {
    //         distinctTitleSet.add(charge.chargeInvoiceTitle)
    //         titles.push({ 'title': charge.chargeInvoiceTitle })
    //       }
    //     }
    //   })
    //   if (distinctTitleSet.size > 1) {
    //     this.updateExistDistinctTitle(true)
    //   } else {
    //     this.updateExistDistinctTitle(false)
    //   }
    //   if (this.defaultTitle && !distinctTitleSet.has(this.defaultTitle)) {
    //     titles.push({ 'title': this.defaultTitle })
    //   }
    //   return titles
    // },
    columnDefs() {
      const self = this
      let list = []
      if (this.reconciliationType === 'job') {
        list = [
          {
            headerName: '',
            checkboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false,
            headerCheckboxSelection: true
          },
          {
            headerName: this.$t('Payment.businessNumber'),
            field: 'jobJobNo',
            width: 200,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              tag: 'router-and-print',
              attrs: {
                useRoute: true,
                usePrint: true,
                routeName: 'FinanceManage',
                routeParamKeys: { jobNo: 'jobJobNo' },
                routeTitle: this.$t('Clearing.FinancialAudit'),
                routePermissions: ['module_ACVerify'],
                extraRouteParams: {}
              }
            }
          },
          { headerName: this.$t('Payment.mbl'), field: 'jobMbl', width: 200 },
          {
            headerName: this.$t('Payment.consignationCompany'),
            field: 'jobCustomerId',
            width: 200,
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(
                TYPE_NAMES.basic_data_Company,
                'cmpIdx',
                params.value,
                'chineseName'
              )
            }
          },
          {
            headerName: this.$t('Payment.settleAccountsTo'),
            field: 'chargeAccountId',
            width: 200,
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(
                TYPE_NAMES.basic_data_Company,
                'cmpIdx',
                params.value,
                'chineseName'
              )
            }
          },
          {
            headerName: this.$t('Payment.carrierId'),
            field: 'jobCarrierId',
            width: 200,
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(
                TYPE_NAMES.basic_data_Company,
                'cmpIdx',
                params.value,
                'chineseName'
              )
            }
          },
          {
            headerName: this.$t('Payment.SONO'),
            field: 'jobSoNo',
            width: 200,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              tag: 'so-no-render',
              attrs: {
                divider: ' '
              }
            }
          },
          {
            headerName: this.$t('SeaExport.OverseaCustomerService'),
            field: 'jobOverseaOp',
            width: 200,
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Payment.businessType'),
            field: 'jobLob',
            width: 200,
            cellRenderer: params => {
              return ColumnUtils.jobBussStateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('Payment.businessDate'),
            field: 'jobBusinessDate',
            width: 100,
            cellRenderer: params => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          { headerName: this.$t('Payment.vesselAndVoyage'), field: 'jobVessel', width: 200 },
          {
            headerName: this.$t('Payment.portOfLoading'),
            field: 'jobLoadingPortCode',
            width: 200,
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            }
          },
          {
            headerName: this.$t('Payment.portOfDestination'),
            field: 'jobDestinationPortCode',
            width: 200,
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            }
          },
          {
            headerName: this.$t('Payment.operation'),
            field: 'jobOp',
            width: 200,
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Payment.sales'),
            field: 'jobSales',
            width: 200,
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Payment.accrued'),
            field: 'jobProvisioned',
            width: 200,
            cellRenderer: params => {
              return ColumnUtils.booleanLabelFunction(params.value)
            }
          },
          { headerName: this.$t('Payment.currency'), field: 'chargeCurrency', width: 200 },
          {
            headerName: this.$t('Payment.taxIncludedPrice'),
            field: 'chargeAmounts',
            width: 200,
            cellRenderer: params => {
              return formatNumberToThousands(params.value, 2)
            }
          },
          { headerName: this.$t('SeaExport.UserDefinedField1'), field: 'jobUserDefinedField1', width: 200 },
          { headerName: this.$t('SeaExport.UserDefinedField2'), field: 'jobUserDefinedField2', width: 200 },
          { headerName: this.$t('SeaExport.UserDefinedField3'), field: 'jobUserDefinedField3', width: 200 },
          {
            headerName: 'ETA',
            field: 'jobEta',
            width: 120,
            hide: true,
            cellRenderer: params => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: 'ETD',
            field: 'jobEtd',
            width: 120,
            hide: true,
            cellRenderer: params => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: 'ATD',
            colId: 'jobAtd',
            field: 'jobAtd',
            width: 120,
            cellRenderer: params => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            hide: true
          },
          {
            headerName: 'ATA',
            colId: 'jobAta',
            field: 'jobAta',
            width: 120,
            cellRenderer: params => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            hide: true
          },
          {
            headerName: this.$t('queryJob.route'),
            field: 'jobTransportLine',
            colId: 'jobTransportLine',
            valueFormatter: params => {
              return ColumnUtils.routeLabelFunctionForBill(params.data)
            },
            initialWidth: 200,
            hide: true
          },
          {
            headerName: this.$t('SeaExport.ProjectName'),
            field: 'jobProjectName',
            colId: 'jobProjectName',
            hide: true,
            width: 150
          },
          {
            headerName: this.$t('CargoMsg.Cargo_AccountPeriod'),
            field: 'creditDateLimited',
            colId: 'creditDateLimited',
            width: 100,
            hide: true,
            cellRenderer: params => ColumnUtils.AccountPeriodLabelFunc(params.data),
            filterParams: {},
            filterValueGetter: params => ColumnUtils.AccountPeriodLabelFunc(params.data)
          },
          {
            headerName: this.$t('queryJob.grossProfitRate'),
            suppressColumnsToolPanel: !this.showGrossProfit,
            hide: true,
            colId: 'grossProfit',
            field: 'grossProfit',
            width: 180,
            valueFormatter: params => {
              return params.data ? params.data.grossProfit : '0.00'
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_LinesArAp'),
            field: 'lineNumber',
            width: 100
          },
          {
            headerName: this.$t('CargoMsg.Cargo_RInPay'),
            field: 'arIncludeAp',
            width: 100,
            cellRenderer: params => {
              return ColumnUtils.IsBookedLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_GPExplain'),
            field: 'explainGp',
            width: 100
          },
          {
            headerName: this.$t('SeaExport.BookingAgent'),
            field: 'jobBookingAgent',
            colId: 'jobBookingAgent',
            hide: true,
            cellRenderer: params => {
              if (
                params.data &&
                (params.data.jobLob === SystemConstants.SI.code || params.data.jobLob === SystemConstants.AI.code)
              ) {
                return ''
              }
              return params.value
                ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_1')
                : ''
            },
            initialWidth: 200
          },
          {
            headerName: this.$t('SeaExport.BillExchangeAgent'),
            field: 'exChangeAgent',
            colId: 'exChangeAgent',
            hide: true,
            cellRenderer: params => {
              if (
                params.data &&
                (params.data.jobLob === SystemConstants.SI.code || params.data.jobLob === SystemConstants.AI.code)
              ) {
                return params.data.jobBookingAgent
                  ? CustomLableUtils.getLabel(
                    TYPE_NAMES.basic_data_Company,
                    'cmpIdx',
                    params.data.jobBookingAgent,
                    'auto_1'
                  )
                  : ''
              }
              return params.value
                ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_1')
                : ''
            },
            initialWidth: 200
          }
        ]
      } else {
        list = [
          {
            headerName: '',
            checkboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false,
            headerCheckboxSelection: true,
            lockVisible: true
          },
          {
            headerName: this.$t('FinanceManage.charge_whtTaxAmount'),
            field: 'chargeWhtTaxLocalAmount',
            width: 100,
            hide: !this.showWhtTax,
            suppressColumnsToolPanel: !this.showWhtTax,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.00')
            }
          },
          {
            headerName: this.$t('FinanceManage.charge_notWhtAmount'),
            field: 'chargeNotWhtAmount',
            width: 100,
            hide: !this.showWhtTax,
            suppressColumnsToolPanel: !this.showWhtTax,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.00')
            }
          },
          {
            headerName: this.$t('FinanceManage.charge_whtTaxRate'),
            field: 'chargeWhtTaxRate',
            width: 100,
            hide: !this.showWhtTax,
            suppressColumnsToolPanel: !this.showWhtTax,
            valueFormatter: params => {
              return this.$numeral(params.value).format('0.00')
            }
          },
          {
            headerName: this.$t('Payment.businessNumber'),
            field: 'jobJobNo',
            width: 200,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              tag: 'router-and-print',
              attrs: params => {
                const data = params.data
                return getJumpFinaceOrBusinessAttrs(true, false, data.jobJobNo, data.jobLob, data.chargeBranchId)
              }
            },
            onCellClicked: params => {
              if (params.event.target.tagName === 'A') {
                self.$refs.cargoDialog.minSize = true
                this.$emit('hiddenDialog', true)
              }
            }
          },
          {
            headerName: this.$t('Payment.consignationCompany'),
            field: 'jobCustomerId',
            width: 200,
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(
                TYPE_NAMES.basic_data_Company,
                'cmpIdx',
                params.value,
                'chineseName'
              )
            }
          },
          {
            headerName: this.$t('Payment.operation'),
            field: 'jobOp',
            width: 100,
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Payment.settlementCompany'),
            field: 'chargeAccountId',
            width: 200,
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(
                TYPE_NAMES.basic_data_Company,
                'cmpIdx',
                params.value,
                'chineseName'
              )
            }
          },
          {
            headerName: this.$t('Payment.businessDate'),
            field: 'jobBusinessDate',
            width: 150,
            cellRenderer: params => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('Payment.chargeItem'),
            field: 'chargeChargeItemId',
            width: 150,
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabelChargeItemLanguage(
                TYPE_NAMES.basic_data_ChargeItem,
                'itemId',
                params.value,
                'zhName'
              )
            }
          },
          { headerName: this.$t('Payment.currency'), field: 'chargeCurrency', width: 100 },
          {
            headerName: this.$t('Payment.paymentType'),
            field: 'chargeReceivable',
            width: 100,
            cellRenderer: params => {
              return ColumnUtils.chargeReceivableLabelFun(params.value)
            }
          },
          {
            headerName: this.$t('Payment.SONO'),
            field: 'jobSoNo',
            width: 150,
            valueFormatter: params => {
              return params.value.replace(/\n/g, ',')
            }
          },
          { headerName: this.$t('Payment.mbl'), field: 'jobMbl', width: 150 },
          { headerName: this.$t('Insurance.InvoiceNumber'), field: 'chargeInvoiceNo', width: 150 },
          {
            headerName: this.$t('Payment.taxIncludedPrice'),
            field: 'chargeAmount',
            width: 150,
            cellRenderer: params => {
              return formatNumberToThousands(params.value, 2)
            }
          },
          {
            headerName: this.$t('Payment.taxExcludedPrice'),
            field: 'chargeExcludingTaxAmount',
            width: 150,
            cellRenderer: params => {
              return formatNumberToThousands(params.value, 2)
            }
          },
          {
            headerName: this.$t('Payment.taxAmount'),
            field: 'chargeTaxAmount',
            width: 150,
            cellRenderer: params => {
              return params.value === 0 ? '' : formatNumberToThousands(params.value, 2)
            }
          },
          {
            headerName: this.$t('Payment.taxRate'),
            field: 'chargeTaxRate',
            width: 150,
            cellRenderer: params => {
              return params.value === 0 ? '' : formatNumberToThousands(params.value, 2)
            }
          },
          {
            headerName: 'ETA',
            field: 'jobEta',
            width: 120,
            hide: true,
            cellRenderer: params => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: 'ETD',
            field: 'jobEtd',
            width: 120,
            hide: true,
            cellRenderer: params => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: 'ATD',
            field: 'jobAtd',
            width: 120,
            hide: true,
            cellRenderer: params => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: 'ATA',
            field: 'jobAta',
            width: 120,
            hide: true,
            cellRenderer: params => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ChargeChanger'),
            colId: 'chargeChanger',
            field: 'chargeChanger',
            initialWidth: 180,
            hide: true,
            valueFormatter: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('queryJob.FLCLType'),
            colId: 'containerLoadType',
            field: 'containerLoadType',
            width: 200,
            hide: true,
            valueFormatter: params => {
              return ColumnUtils.loadTypeLabelFunction(params.data, 'containerLoadType')
            }
          },
          {
            headerName: this.$t('Payment.solicitationType'),
            field: 'jobCargoSource',
            width: 200,
            hide: true,
            valueFormatter: params => {
              return ColumnUtils.cargoSourceLabelFunction(params.value)
            }
          },
          { headerName: this.$t('Payment.chargeRemark'), field: 'chargeRemarks', width: 200 },
          {
            headerName: this.$t('Invoice.invoice_receivablesInvoicingStatus'),
            colId: 'invoiceStateReceivable',
            field: 'invoiceStateReceivable',
            width: 200,
            valueFormatter: params => {
              return typeof params.value === 'number'
                ? ColumnUtils.receivableInvoiceStateLabelFunction(params.value)
                : ''
            },
            hide: true
          },
          {
            headerName: this.$t('queryJob.receivablesWriteOfStatus'),
            colId: 'verifyStateReceivable',
            field: 'verifyStateReceivable',
            width: 180,
            valueFormatter: params => {
              return typeof params.value === 'number' ? ColumnUtils.writeOffStateLabFun(String(params.value)) : ''
            },
            hide: true
          },
          {
            headerName: this.$t('FinanceManage.charge_payReceiveDate'),
            colId: 'chargePayReceiveDate',
            field: 'chargePayReceiveDate',
            width: 180,
            valueFormatter: params => {
              return DateUtils.formatStandardDate(params.value)
            },
            hide: true
          },
          {
            headerName: this.$t('FinanceManage.charge_writeOffDate'),
            colId: 'chargeClearingDate',
            field: 'chargeClearingDate',
            width: 180,
            valueFormatter: params => {
              return DateUtils.formatStandardDate(params.value)
            },
            hide: true
          },
          {
            headerName: this.$t('FinanceManage.charge_invoiceHeader'),
            colId: 'chargeInvoiceTitle',
            field: 'chargeInvoiceTitle',
            hide: true,
            width: 180
          },
          {
            headerName: this.$t('queryJob.grossProfitRate'),
            suppressColumnsToolPanel: !this.showGrossProfit,
            hide: true,
            colId: 'grossProfit',
            field: 'grossProfit',
            width: 180,
            valueFormatter: params => {
              return params.data ? params.data.grossProfit : '0.00'
            }
          },
          {
            headerName: this.$t('queryJob.sales'),
            field: 'salesId',
            hide: true,
            width: 180,
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('queryJob.salesDepartment'),
            field: 'salesDepartmentId',
            hide: true,
            width: 180,
            cellRenderer: params => {
              return ColumnUtils.resolveColumnLabel(
                TYPE_NAMES.basic_data_Department_All,
                'departmentId',
                params.value,
                'chineseName'
              )
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_LinesArAp'),
            field: 'lineNumber',
            width: 100
          },
          {
            headerName: this.$t('CargoMsg.Cargo_RInPay'),
            field: 'arIncludeAp',
            width: 100,
            cellRenderer: params => {
              return ColumnUtils.IsBookedLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_GPExplain'),
            field: 'explainGp',
            width: 100
          },
          {
            headerName: this.$t('Payment.exchangeRate'),
            field: 'chargeExchangeRate',
            hide: true,
            width: 180,
            cellRenderer: params => {
              return ColumnUtils.numberColumnLabelFunc(params.value, 8)
            }
          },
          {
            headerName: this.$t('SeaExport.BusinessReferenceNo'),
            field: 'customerRefNo',
            hide: true,
            width: 150,
            cellRenderer: params => {
              return params.data.customerRefNo ? params.data.customerRefNo : params.data.jobCustomerRefNo
            }
          },
          {
            headerName: this.$t('queryJob.profit'),
            field: 'profit',
            colId: 'profit',
            width: 200
          }
        ]
      }
      if (this.isSpecialExpenseEntryFunction) {
        list.push(
          {
            headerName: this.$t('CargoMsg.Cargo_GrossProfitAmount'),
            colId: 'grossProfitAmount',
            field: 'grossProfitAmount',
            hide: true,
            initialWidth: 100
          },
          {
            headerName: this.$t('CargoMsg.Cargo_SpecialExpensePayableTotal'),
            colId: 'specialChargeApSum',
            field: 'specialChargeApSum',
            hide: true,
            initialWidth: 100
          },
          {
            headerName: this.$t('CargoMsg.Cargo_SpecialExpensePayableCurrency'),
            colId: 'specialChargeApCurrency',
            field: 'specialChargeApCurrency',
            hide: true,
            initialWidth: 100
          },
          {
            headerName: this.$t('CargoMsg.Cargo_SpecialExpenseReceivableTotal'),
            colId: 'specialChargeArSum',
            field: 'specialChargeArSum',
            hide: true,
            initialWidth: 100
          },
          {
            headerName: this.$t('CargoMsg.Cargo_SpecialExpenseReceivableCurrency'),
            colId: 'specialChargeArCurrency',
            field: 'specialChargeArCurrency',
            hide: true,
            initialWidth: 100
          }
        )
      }
      return list
    },
    showRateByCharge() {
      // 显示按费用汇率创建
      return this.billPayment.currency === 'RMB' && this.viewSource === 'billPayment'
    },
    exchangeRatePrecision() {
      return CurrencyUtil.getCurrencyRateDigits(
        this.otherCurrencyArray.length > 0 ? this.otherCurrencyArray[0] : this.billPayment.currency
      )
    },
    rate1Precision() {
      return CurrencyUtil.getCurrencyRateDigits(this.billPayment.currency1)
    },
    rate2Precision() {
      return CurrencyUtil.getCurrencyRateDigits(this.billPayment.currency2)
    },
    rate3Precision() {
      return CurrencyUtil.getCurrencyRateDigits(this.billPayment.currency3)
    },
    chargeCurrencySet() {
      return new Set(this.rowData.map(item => item.chargeCurrency))
    },
    ifJc() {
      return this.viewSource === 'JC'
    },
    singleRateView() {
      return this.viewSource === 'JC' || this.toExoSystemYGSH
    },
    ifHistoryPayment() {
      if (!this.billPayment.uuid) {
        return false
      }
      let ifHistory = true
      for (let i = 1; i <= 3; i++) {
        ifHistory = ifHistory && !this.billPayment['currency' + i]
      }
      return ifHistory
    }
  },
  watch: {
    '$store.state.dialogStatus.approveDialogShow': {
      handler(value) {
        if (value) {
          this.$refs.cargoDialog.minSize = false
        }
      },
      deep: true
    },
    // 付款申请单状态
    'billPayment.state': {
      handler: function(val) {
        const state = CommonState.getStateByCode(ClearingConstants.BILL_PAYMENT_STATES, Number(!val ? 0 : val))
        this.stateText = this.$store.getters.language === 'zh' ? state.chineseName : state.englishName
      },
      deep: true
    },
    //  结算代理
    'billPayment.settlementAgentId': {
      handler: function(val) {
        // 是否勾选结算代理复选框
        this.agentChecked = !!val
      },
      deep: true
    },
    // 结算对象
    'billPayment.accountId': {
      handler: function(val) {
        if (val > 0) {
          if (this.billPayment.settlementAgentId > 0) {
            const settlementAgent = getObjectByCache(
              basicCacheKeys.basic_data_Company,
              'cmpIdx',
              Number(this.billPayment.settlementAgentId)
            )
            if (settlementAgent) {
              this.queryTitleBankList(Number(settlementAgent.cmpIdx))
            }
          } else {
            // 获取结算对象的开票抬头(一定要保证先查询开票抬头，然后再根据开票抬头去查询开票银行)
            this.queryTitleBankList(Number(val))
          }
          // 查询结算代理
          this.querySettlementAgentList(val)
        }
      },
      deep: true
    },
    // 分公司
    'billPayment.branchId': {
      handler: function(val) {
        if (val > 0) {
          const office = getObjectByCache(basicCacheKeys.basic_data_Office, 'officeId', Number(val))
          if (office) {
            const deps = getCacheListByKey(basicCacheKeys.basic_data_Department)
            if (deps && deps.length > 0) {
              this.departmentArray = deps.filter(
                dep => dep.officeUuid === office.uuid && dep.jobNoPrefix && dep.jobNoPrefix !== ''
              )
            } else {
              this.departmentArray = []
            }
          }
        }
      },
      deep: true
    },
    // REQ-0033：付款类型/当前公司任一变化即重取后端清洗配置（原 enterpriseWechatTemplateUuid watch 语义平移）
    wechatFormConfigTrigger: {
      immediate: true,
      handler: function() {
        // 仅当付款类型已选时取企微字段配置并设置默认水单通知人
        const paymentType = this.billPayment && this.billPayment.paymentType
        if (paymentType !== undefined && paymentType !== null && paymentType !== '') {
          this.loadEnterpriseWechatFormConfig()
          this.setDefaultWaterNotifier()
        }
      }
    },
    // 企微「付款公司」变更时，自动匹配我方发票抬头（系统维护：发票抬头-企微审批付款公司）。
    // 本 watcher 覆盖回显/初始化等程序化赋值：未匹配时保留已有我方抬头（keepWhenUnmatched）；
    // 用户在企微字段中主动切换付款公司由 mixin 选择回调直调（keepWhenUnmatched: false，未匹配清空）
    'billPayment.paymentCompany': {
      immediate: true,
      handler: function(val) {
        this.syncOurTitleByPaymentCompany(val, { keepWhenUnmatched: true })
      }
    },
    billPaymentUuid: {
      immediate: true,
      handler: function(val) {
        this.curBillPaymentUuid = val
        if (val) {
          // 查看编辑付款申请单
          this.queryBillPayment(val)
        }
      }
    }
  },
  beforeCreate() {
    this.$options.components.BillPaymentWorkFlowApplyDialog = BillPaymentWorkFlowApplyDialog
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    await this.initConfig()
    await this.initCustomFields()
    await this.initTitles()
  },
  beforeMount() {
    // 初始化保存按钮状态
    this.btnSaveEnable = false
    this.canUseBillingRate = false
    this.billCurrencyList = []
    const curBillPaymentUuid = this.curBillPaymentUuid
    if (curBillPaymentUuid) {
      // 查看编辑付款申请单
      this.queryBillPayment(curBillPaymentUuid)
    }
  },
  destroyed() {
    console.log('dialog-destroy', this)
  },
  mounted() {
    this.deadlineConfig = Number(cache.config.get('DeadlineConfig'))
  },
  methods: {
    invoiceTitleChange(p) {
      const value = p && typeof p === 'object' ? p.value : p
      this.billPayment.invoiceTitle = value || ''
      this.titleBankArray = this.filterTitleBankArrayByInvoiceTitle(
        this.allTitleBankArray,
        this.billPayment.invoiceTitle
      )
      this.syncTitleBankSelection({ resetSelection: true })
    },
    filterTitleBankArrayByInvoiceTitle(allTitleBanks, invoiceTitle) {
      const title = typeof invoiceTitle === 'string' ? invoiceTitle.trim() : invoiceTitle
      const banks = Array.isArray(allTitleBanks) ? allTitleBanks : []
      return title ? banks.filter(row => row && row.title && row.title.title === title) : banks
    },
    syncTitleBankSelection({ resetSelection = false } = {}) {
      if (!this.billPayment) return
      if (this.titleBankArray && this.titleBankArray.length > 0) {
        if (resetSelection) {
          const defaultRow = this.titleBankArray.find(row => row && row.defaultBank) || this.titleBankArray[0]
          this.billPayment.buyerBank = defaultRow.bank || ''
          this.billPayment.buyerBankAccount = defaultRow.bankAccount || ''
          this.buyerBankUuid = defaultRow.uuid || ''
          return
        }
        const hasMatch = this.titleBankArray.find(
          item => item.bank === this.billPayment.buyerBank && item.bankAccount === this.billPayment.buyerBankAccount
        )
        if (!hasMatch) {
          const first = this.titleBankArray[0]
          this.billPayment.buyerBank = first.bank || ''
          this.billPayment.buyerBankAccount = first.bankAccount || ''
          this.buyerBankUuid = first.uuid || ''
        } else {
          this.buyerBankUuid = hasMatch.uuid || this.buyerBankUuid
        }
      } else if (resetSelection) {
        this.billPayment.buyerBank = ''
        this.billPayment.buyerBankAccount = ''
        this.buyerBankUuid = ''
      }
    },
    // 初始化自定义字段
    async initCustomFields() {
      const res = await getCustomFieldList({ fieldDisplay: SystemConstants.FIELD_DISPLAY_PAYMENT_REQUEST_MODULE.code })
      if (res.data.list && res.data.list.length > 0) {
        this.customFields = res.data.list.sort((a, b) => a.fieldCode - b.fieldCode)
        this.customFields.forEach(obj => {
          if (obj.enumStr) {
            obj.enums = obj.enumStr.split(',').map(p => {
              return { tagName: p, tagValue: p }
            })
          }
          const value = this.billPayment[SystemConstants.CUSTOM_FIELDS_PAYMENT_REQUEST_MAP.get(obj.fieldCode)]
          if (obj.enums && obj.enums.length > 0) {
            const row = obj.enums.find(p => p.tagValue === value)
            if (!row) {
              obj.enums.push({ tagName: value, tagValue: value, notShowInOptions: true })
            }
          } else {
            obj.enums = [{ tagName: value, tagValue: value, notShowInOptions: true }]
          }
        })
      }
    },
    initTitles() {
      // 获取发票抬头列表
      this.getInvoiceTitlesByOfficeCache.execute({ officeId: this.$store.getters.currentOfficeId }).then(res => {
        this.ourInvoiceTitleArray = res.data
        const value = this.billPayment.ourTitle
        if (this.ourInvoiceTitleArray && this.ourInvoiceTitleArray.length > 0) {
          const row = this.ourInvoiceTitleArray.find(p => p.tagValue === value || p.invoiceTitle === value)
          if (!row) {
            this.ourInvoiceTitleArray.push({ invoiceTitle: value, tagValue: value, notShowInOptions: true })
          }
        } else {
          this.ourInvoiceTitleArray = [{ invoiceTitle: value, tagValue: value, notShowInOptions: true }]
        }
        // 企微付款公司可能已存在（编辑/反显场景），此处拿到抬头列表后补做一次自动匹配；
        // 初始化补做未匹配时保留已保存的我方抬头（用户切换付款公司由 mixin 回调直调，允许清空）
        this.syncOurTitleByPaymentCompany(this.billPayment && this.billPayment.paymentCompany, { keepWhenUnmatched: true })
      })
    },
    syncOurTitleByPaymentCompany(paymentCompany, { keepWhenUnmatched = false } = {}) {
      if (!this.billPayment) return
      const company = typeof paymentCompany === 'string' ? paymentCompany.trim() : ''
      // paymentCompany 为空时不改动我方抬头：
      // 1) 避免页面首次加载/反显时（抬头列表未加载或付款公司未选择）误清空已有 ourTitle
      // 2) 允许用户在未选择付款公司时手动选择我方抬头
      if (!company) return

      const titles = Array.isArray(this.ourInvoiceTitleArray) ? this.ourInvoiceTitleArray : []
      // 抬头列表未加载完成前无法匹配，等待 initTitles() 拿到列表后再次调用本方法
      if (titles.length === 0) return

      const matched = titles.find(row => {
        const wechatPayCompany =
          row && typeof row.enterpriseWechatPayCompany === 'string' ? row.enterpriseWechatPayCompany.trim() : ''
        return wechatPayCompany && wechatPayCompany === company
      })
      if (!matched) {
        // keepWhenUnmatched=true：回显/初始化场景，抬头主数据未维护映射时保留已保存的
        // ourTitle，避免每次打开详情被清空；用户主动切换付款公司走默认 false，未匹配清空
        if (!keepWhenUnmatched) {
          this.billPayment.ourTitle = ''
        }
        return
      }

      const targetTitle = matched.invoiceTitle || matched.tagValue || ''
      if (targetTitle && this.billPayment.ourTitle !== targetTitle) {
        this.billPayment.ourTitle = targetTitle
      }
    },
    // 配置参数
    async initConfig() {
      this.toExoSystemHC = String(cache.config.get('ToExoSystem')) === 'HC' // 海创
      // 是否显示毛利率
      this.showGrossProfit = Number(cache.config.get('ShowGrossProfit')) === 1
      this.isSpecialExpenseEntryFunction = Number(cache.config.get('SpecialExpenseEntryFunction')) === 1
    },
    // 初始化付款申请
    async initBillPayment(
      charges = [],
      { curBillPaymentUuid, accountId, settlementAgentId, currency, invoiceCurrencyMap } = {}
    ) {
      if (!charges || charges.length === 0) return
      const billPayment = new BillPayment().fillDefaultValue().getData()
      this.rowData = charges
      this.rowData.forEach(e => {
        if (!e.chargeBillUuid) {
          e.chargeBillUuid = e.billingUuid
        }
      })
      // 将发票上分币种汇率记录下
      this.invoiceCurrencyRate = invoiceCurrencyMap
      this.originalCurrency = currency
      const charge = charges[0]
      billPayment.branchId = this.$store.getters.currentOfficeId
      billPayment.inputBy = this.$store.getters.userInfo.userId
      billPayment.inputDate = moment(new Date()).format('yyyy-MM-DD')
      billPayment.uuid = curBillPaymentUuid || ''
      billPayment.accountId = accountId || charge.chargeAccountId
      billPayment.settlementAgentId = settlementAgentId || 0
      billPayment.state = 0
      billPayment.paymentType = '0'
      billPayment.syncInvoiceAttachment = true
      this.deadlineConfig = Number(cache.config.get('DeadlineConfig'))
      // CARGO-17402 付款申请-创建付款申请时付款期限需默认空白
      if (this.deadlineConfig !== -1) {
        const today = new Date()
        const defaultDeadline = new Date()
        defaultDeadline.setDate(today.getDate() + this.deadlineConfig)
        billPayment.deadline = defaultDeadline.toISOString()
      }
      const state = CommonState.getStateByCode(ClearingConstants.BILL_PAYMENT_STATES, Number(billPayment.state))
      this.stateText = this.$store.getters.language === 'zh' ? state.chineseName : state.englishName
      billPayment.se = false
      billPayment.si = false
      billPayment.ae = false
      billPayment.ai = false
      billPayment.ri = false
      billPayment.re = false
      billPayment.ie = false
      billPayment.fba = false
      this.jobTypes = []
      for (const charge of charges) {
        this.addLob(charge, billPayment, SystemConstants.BILL_PAYMENT_LOBS)
      }
      billPayment.currency = currency || charge.chargeCurrency
      // 付款方式默认为银行转账
      billPayment.payType = 2
      if (LocalStorageUtilsNew.hasConfiguration('billPaymentFormPage')) {
        const item = LocalStorageUtilsNew.getConfiguration('billPaymentFormPage')
        billPayment.paymentType = item.paymentType
        billPayment.ourTitle = item.ourTitle
      }
      this.billPayment = billPayment
      this.querySettlementAgentList(billPayment.accountId)
      if (!this.singleRateView) {
        await this.getChargeBillingMultiCurrencyInfo()
      }
      await this.currencyChange(billPayment.currency, true)
      this.calCurrencyAmount()
      if (this.ifJc) {
        this.checkChargeSameTitle()
        this.getTitleArrayJc()
      } else {
        // 初始化开票抬头下拉数据
        const cmpIdxList = []
        cmpIdxList.push(billPayment.accountId)
        await getTitleByCmpIdxList(cmpIdxList).then(res => {
          const titles = res.data
          if (titles && titles.length > 0) {
            // 默认抬头取结算对象的默认抬头
            this.defaultTitle = titles[0].title
            this.defaultTitleUuid = titles[0].uuid
          } else {
            // 默认抬头取结算对象
            this.defaultTitle = ColumnUtils.resolveColumnLabel(
              TYPE_NAMES.basic_data_Company,
              'cmpIdx',
              billPayment.accountId,
              'chineseName'
            )
          }
          const distinctTitleSet = new Set()
          this.rowData.forEach(charge => {
            if (charge.chargeInvoiceTitle) {
              if (!distinctTitleSet.has(charge.chargeInvoiceTitle)) {
                distinctTitleSet.add(charge.chargeInvoiceTitle)
              }
            }
          })
          this.getTitleArray()
          if (distinctTitleSet.size === 0 || distinctTitleSet.size > 1) {
            this.billPayment.invoiceTitle = this.defaultTitle
          }
          if (distinctTitleSet.size === 1) {
            this.billPayment.invoiceTitle = this.titleArray[0].title
          }
        })
      }
      await this.currencyChangeUpdateBuyerBank(billPayment.currency)
    },
    ourTitleChangeEvent(p) {
      if (p) {
        this.billPayment.ourTitle = p.value
      } else {
        this.billPayment.ourTitle = ''
      }
    },
    addLob(charge, billPayment, lobs) {
      // 先判断是否fba
      if (charge.fba) {
        billPayment['fba'] = true
        if (this.jobTypes.indexOf('FBA') < 0) {
          this.jobTypes.push('FBA')
        }
        return
      }
      for (const state of lobs) {
        const lob = state.code
        if (charge.jobLob && charge.jobLob === lob) {
          billPayment[lob.toLowerCase()] = true
          if (this.jobTypes.indexOf(lob) < 0) {
            this.jobTypes.push(lob)
          }
          return
        }
      }
    },
    // 查询付款申请
    queryBillPayment(curBillPaymentUuid = null) {
      queryBillPaymentDetail({
        billPaymentUuid: curBillPaymentUuid,
        paging: false,
        branchId: this.$store.getters.currentOfficeId
      }).then(res => {
        this.billPayment = res.data
        if (this.billPayment.se) {
          this.jobTypes.push('SE')
        }
        if (this.billPayment.si) {
          this.jobTypes.push('SI')
        }
        if (this.billPayment.ae) {
          this.jobTypes.push('AE')
        }
        if (this.billPayment.ai) {
          this.jobTypes.push('AI')
        }
        if (this.billPayment.ri) {
          this.jobTypes.push('RI')
        }
        if (this.billPayment.re) {
          this.jobTypes.push('RE')
        }
        if (this.billPayment.ie) {
          this.jobTypes.push('IE')
        }
        if (this.billPayment.fba) {
          this.jobTypes.push('FBA')
        }
        this.queryChargeOfBillPayment(this.billPayment.uuid)
      })
    },
    // 查询付款申请单关联的费用
    queryChargeOfBillPayment(curBillPaymentUuid = null) {
      this.loading = getLoading4Cxt()
      const requestBody = {
        billPaymentUuid: curBillPaymentUuid,
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        branchId: this.$store.getters.currentOfficeId
      }
      queryChargeOfBillPayment(requestBody)
        .then(async res => {
          this.rowData = res.data.list ? res.data.list : []
          this.pagination.total = Number(res.data.total)
          this.refreshChargeNotWhtAmount()
          if (!this.singleRateView) {
            await this.getChargeBillingMultiCurrencyInfo()
            await this.initMultiCurrencyRate()
          }
          await this.rateLabelChange(this.billPayment.currency, this.rowData, false)
          // 初始化开票抬头下拉数据
          const cmpIdxList = []
          cmpIdxList.push(this.billPayment.accountId)
          await getTitleByCmpIdxList(cmpIdxList).then(res => {
            const titles = res.data
            if (titles && titles.length > 0) {
              // 默认抬头取结算对象的默认抬头
              this.defaultTitle = titles[0].title
            } else {
              // 默认抬头取结算对象
              this.defaultTitle = ColumnUtils.resolveColumnLabel(
                TYPE_NAMES.basic_data_Company,
                'cmpIdx',
                this.billPayment.accountId,
                'chineseName'
              )
            }
          })
        })
        .finally(() => {
          this.loading.close()
        })
    },
    queryJobOfBillPayment(curBillPaymentUuid = null) {
      this.loading = getLoading4Cxt()
      const requestBody = {
        billPaymentUuid: curBillPaymentUuid,
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        branchId: this.$store.getters.currentOfficeId
      }
      this.rowData = []
      queryJobOfBillPayment(requestBody)
        .then(async res => {
          if (res.data.list && res.data.list.length > 0) {
            this.rowData = [...res.data.list]
          } else {
            this.rowData = []
          }
        })
        .finally(() => {
          this.loading.close()
        })
    },
    billPaymentNoLink() {
      if (!this.$checkPermission(['module_ACVerify'])) {
        this.$message.error(this.$t('Message.YouToOpenTheModule', [this.$t('CargoMsg.Cargo_FinancialAudit')]))
        return
      }
      this.$refs.cargoDialog.minSize = true
      const oldRoute = this.$route
      const params = { billPaymentNo: this.billPayment.billPaymentNo }
      this.$router.push({ name: 'FinanceManage', params })
      // 路由无变化，手动刷新
      if (this.$route === oldRoute) {
        const view = this.$store.state.tagsView.visitedViews.find(v => matchView(v, this.$route))
        Object.assign(view.params, params)
        refreshView(view)
      }
    },
    // 获取各费用账单币种与汇率对应关系
    async getChargeBillingMultiCurrencyInfo() {
      this.billingList = []
      this.canUseBillingRate = false
      const noBillCharge = this.rowData.find(item => !item.chargeBillUuid && !item.billingUuid)
      if (!noBillCharge && this.rowData && this.rowData.length > 0) {
        await getChargeBillingMultiCurrencyInfo([...new Set(this.rowData.map(item => item.chargeBillUuid))])
          .then(res => {
            if (res.ok) {
              this.billingList = res.data
            }
          })
          .catch(() => {})
        this.canUseBillingRate = this.ifBillCurrencySameAsPayment()
      }
      // 判断是否可以保持按账单汇率付款状态（如新增/删除 已有账单/无账单费用）
      this.billPayment.payByBillingRate = this.billPayment.payByBillingRate && this.canUseBillingRate
    },
    ifBillCurrencySameAsPayment(currency = '') {
      let same = false
      if (this.billingList && this.billingList.length > 0) {
        let billCurrency = this.billingList[0].currency
        for (const bill of this.billingList) {
          if (bill.currency !== billCurrency) {
            billCurrency = ''
            break
          }
        }
        same = billCurrency === (currency || this.billPayment.currency)
      }
      return same
    },
    async payByBillingRateChanged() {
      if (this.billPayment.payByBillingRate && this.billPayment.rateByCharge) {
        this.billPayment.rateByCharge = false
      }
      await this.initMultiCurrencyRate(true)
      this.refreshAmount()
    },
    // 初始化币种与汇率对应关系
    async initMultiCurrencyRate(changeRate = false) {
      const charges = this.rowData
      this.currencyRateMap = {}
      this.billCurrencyList = []
      if (changeRate) {
        for (let i = 1; i <= 3; i++) {
          this.billPayment['currency' + i] = ''
          this.billPayment['rate' + i] = 0
        }
      }
      // 当是从发票进来的付款申请，默认使用发票上汇率
      // 付款申请币种修改后，走原逻辑
      if (this.invoiceCurrencyRate && this.originalCurrency === this.billPayment.currency) {
        let multiIdx = 1
        for (const currency of this.chargeCurrencySet) {
          if ((!this.billPayment['currency' + multiIdx] && !this.billPayment.uuid) || changeRate) {
            this.billPayment['currency' + multiIdx] = currency
          }
          if ((!this.billPayment['rate' + multiIdx] && !this.billPayment.uuid) || changeRate) {
            this.billPayment['rate' + multiIdx] =
              this.invoiceCurrencyRate[currency] ||
              RateUtil.getForeignExchangeRateSafely(
                this.billPayment.currency,
                currency,
                new Date(),
                this.billPayment.branchId
              )
          }
          multiIdx++
        }
      } else {
        // 所有费用都开过账单，校验各账单币种与付款申请币种是否相同
        const useBill = this.ifBillCurrencySameAsPayment()
        // 使用账单币种
        if (this.billPayment.payByBillingRate && useBill) {
          // key为币种，value为同币种汇率列表，方便后续算平均值
          const billCurrencyRateListMap = {}
          for (const bill of this.billingList) {
            for (let i = 1; i <= 3; i++) {
              const currency = bill['sourceCurrency' + i]
              const rate = bill['sourceRate' + i]
              if (currency && rate) {
                let rateList = billCurrencyRateListMap[currency]
                if (rateList && rateList.length > 0) {
                  rateList.push(Number(rate))
                } else {
                  rateList = []
                  rateList.push(Number(rate))
                }
                billCurrencyRateListMap[currency] = rateList
              }
            }
          }
          let multiIdx = 1
          for (const currency of this.chargeCurrencySet) {
            this.billCurrencyList.push(currency)
            if (billCurrencyRateListMap.hasOwnProperty(currency)) {
              const rateList = billCurrencyRateListMap[currency]
              let rateSum = 0
              for (const rate of rateList) {
                rateSum += rate
              }
              const rateAve = NumberUtils.ToFixed2(rateList.length === 1 ? rateSum : rateSum / rateList.length, 8)
              if ((!this.billPayment['currency' + multiIdx] && !this.billPayment.uuid) || changeRate) {
                this.billPayment['currency' + multiIdx] = currency
              }
              if ((!this.billPayment['rate' + multiIdx] && !this.billPayment.uuid) || changeRate) {
                this.billPayment['rate' + multiIdx] = rateAve
              }
              multiIdx++
            }
          }
        } else {
          // 使用费用币种
          if (charges && charges.length > 0) {
            let multiIdx = 1
            for (const currency of this.chargeCurrencySet) {
              if ((!this.billPayment['currency' + multiIdx] && !this.billPayment.uuid) || changeRate) {
                this.billPayment['currency' + multiIdx] = currency
              }
              if ((!this.billPayment['rate' + multiIdx] && !this.billPayment.uuid) || changeRate) {
                this.billPayment['rate' + multiIdx] = RateUtil.getForeignExchangeRateSafely(
                  this.billPayment.currency,
                  currency,
                  new Date(),
                  this.billPayment.branchId
                )
              }
              multiIdx++
            }
          }
        }
      }

      for (let i = 1; i <= 3; i++) {
        if (this.billPayment['currency' + i] && this.billPayment['rate' + i]) {
          this.currencyRateMap[this.billPayment['currency' + i]] = this.billPayment['rate' + i]
        }
      }
    },
    // 汇率标题修改事件
    async rateLabelChange(currency = '', charges = [], changeRate = false) {
      if (currency && charges && charges.length > 0) {
        const otherCurrencyArray = []
        for (const charge of charges) {
          const chargeCurrency = charge.chargeCurrency
          if (
            chargeCurrency &&
            chargeCurrency !== this.billPayment.currency &&
            otherCurrencyArray.indexOf(chargeCurrency) < 0
          ) {
            otherCurrencyArray.push(chargeCurrency)
          }
        }
        if (otherCurrencyArray.length > 0) {
          this.rateLabel = otherCurrencyArray[0] + this.$t('Payment.exchangeRate')
          if (changeRate) {
            this.billPayment.rate = await RateUtil.getForeignExchangeRateSafely(
              this.billPayment.currency,
              otherCurrencyArray[0],
              new Date(),
              this.billPayment.branchId
            )
          }
        } else {
          this.rateLabel = this.$t('Payment.exchangeRate')
          if (changeRate) {
            this.billPayment.rate = 1.0
          }
        }
        this.otherCurrencyArray = otherCurrencyArray
      }
    },
    // 费用列表分页事件
    queryPageHandler() {
      if (this.curBillPaymentUuid) {
        this.queryChargeOfBillPayment(this.curBillPaymentUuid)
      }
    },
    async querySettlementAgentList(accountId) {
      const settlementAgentArray = await getSettlementAgentsByCmpIdx(accountId).then(res => {
        return res.data
      })
      if (settlementAgentArray && settlementAgentArray.length > 0) {
        this.settlementAgentArray = settlementAgentArray
      } else {
        this.settlementAgentArray = []
      }
      const index = this.settlementAgentArray.findIndex(p => p.cmpIdx === this.billPayment.settlementAgentId)
      if (index < 0) {
        const settlementAgent = getObjectByCache(
          basicCacheKeys.basic_data_Company,
          'cmpIdx',
          Number(this.billPayment.settlementAgentId)
        )
        if (settlementAgent) {
          this.settlementAgentArray.push(settlementAgent)
        }
      }
    },
    // 查询开户银行
    queryTitleBankList(accountId) {
      if (accountId > 0) {
        allTitleBanksByCmpIdx(accountId).then(res => {
          if ((res.data && res.data.length > 0) || this.billPayment.buyerBank) {
            this.allTitleBankArray = Array.isArray(res.data) ? res.data : []
            this.titleBankArray = this.filterTitleBankArrayByInvoiceTitle(
              this.allTitleBankArray,
              this.billPayment.invoiceTitle
            )
            if (
              !this.allTitleBankArray.find(
                item =>
                  item.bank === this.billPayment.buyerBank && item.bankAccount === this.billPayment.buyerBankAccount
              )
            ) {
              this.allTitleBankArray.push({
                bank: this.billPayment.buyerBank,
                uuid: this.billPayment.uuid,
                bankAccount: this.billPayment.buyerBankAccount,
                currency: this.billPayment.currency,
                title: { title: this.billPayment.invoiceTitle }
              })
              this.titleBankArray = this.filterTitleBankArrayByInvoiceTitle(
                this.allTitleBankArray,
                this.billPayment.invoiceTitle
              )
            }
            this.syncTitleBankSelection({ resetSelection: !this.billPayment.uuid })
          } else {
            this.titleBankArray = []
            this.allTitleBankArray = []
            this.billPayment.buyerBank = ''
            this.billPayment.buyerBankAccount = ''
            this.buyerBankUuid = ''
          }
        })
      }
    },
    // 结算对象变更事件
    accountChange(accountId) {
      if (!this.agentChecked && accountId) {
        this.queryTitleBankList(accountId)
      }
    },
    // 结算代理勾选框变更事件
    cbSettlementAgentChange() {
      if (this.agentChecked) {
        if (this.billPayment.settlementAgentId) {
          this.queryTitleBankList(this.billPayment.settlementAgentId)
        }
      } else {
        this.billPayment.settlementAgentId = 0
        if (this.billPayment.accountId) {
          this.queryTitleBankList(this.billPayment.accountId)
        }
      }
    },
    // 结算代理变更事件
    settlementAgentChange() {
      if (this.agentChecked && this.billPayment.settlementAgentId) {
        this.queryTitleBankList(this.billPayment.settlementAgentId)
      }
    },
    // 币种变更事件
    async currencyChange(currency = null, isChange = false) {
      if (currency && currency !== 'RMB') {
        this.billPayment.rateByCharge = false
      }
      const noBillCharge = this.rowData.find(item => !item.chargeBillUuid && !item.billingUuid)
      if (!noBillCharge) {
        this.canUseBillingRate = this.ifBillCurrencySameAsPayment(currency)
      }
      if (currency) {
        this.billPayment.currency = currency
        if (!this.singleRateView) {
          await this.initMultiCurrencyRate(true)
        }
        await this.rateLabelChange(currency, this.rowData, true)
        await this.refreshAmount()
        this.refreshChargeNotWhtAmount()
        // CARGO-50234 币种发生变更,则需要重新带出开户银行
        if (isChange) {
          await this.currencyChangeUpdateBuyerBank(currency)
        }
      }
    },
    // 币种更新银行账号
    async currencyChangeUpdateBuyerBank(currency) {
      if (this.defaultTitleUuid) {
        const loading = getLoading4Cxt(this)
        let results = []
        await allTitleBanksByCmpIdx(this.billPayment.accountId)
          .then(res => {
            if (res.data && res.data.length > 0) {
              results = res.data
            }
          })
          .finally(() => {
            loading.close()
          })
        if (results && results.length > 0 && currency && this.defaultTitleUuid) {
          const titleBanks = results.filter(
            result => result.currency === currency && result.titleUuid === this.defaultTitleUuid
          )
          if (titleBanks && titleBanks.length > 0) {
            let defaultBank
            for (const titleBank of titleBanks) {
              if (titleBank.defaultBank) {
                defaultBank = titleBank
              }
            }
            if (!defaultBank) {
              defaultBank = titleBanks[0]
            }
            if (defaultBank) {
              this.billPayment.buyerBank = defaultBank['bank']
              this.billPayment.buyerBankAccount = defaultBank['bankAccount']
              this.buyerBankUuid = defaultBank['uuid']
            }
          }
        }
      }
    },
    // 结算公司变更事件
    settleDepartmentPrefixChange(dep) {
      if (dep) {
        this.billPayment.settleDepartmentPrefix = dep.jobNoPrefix ? dep.jobNoPrefix : ''
      } else {
        this.billPayment.settleDepartmentPrefix = ''
      }
    },
    currencyRateChanged(rate, currencyLabel) {
      this.currencyRateMap[this.billPayment[currencyLabel]] = Number(rate)
      this.refreshAmount()
    },
    async rateByChargeChanged() {
      if (this.billPayment.payByBillingRate && this.billPayment.rateByCharge) {
        this.billPayment.payByBillingRate = false
      }
      if (!this.ifHistoryPayment && !this.billPayment.rateByCharge) {
        await this.initMultiCurrencyRate(true)
      }
      this.refreshAmount()
    },
    // 刷新付款申请单金额
    async refreshAmount() {
      let amount = 0
      if (this.rowData && this.rowData.length > 0) {
        // CARGO-38807 H5 BUG 销账/付款申请单界面金额合计显示错误 付款金额
        const amountCurrencys = ChargeUtils.getZeroAmountCurrencys(
          this.rowData,
          'chargeCurrency',
          'chargeAmount',
          'chargeReceivable'
        )
        for (const charge of this.rowData) {
          if (amountCurrencys.includes(charge.chargeCurrency)) continue
          let rate = 1
          if (this.billPayment.rateByCharge && this.showRateByCharge) {
            rate = charge.chargeExchangeRate
          } else {
            // CARGO-39011 付款申请支持三币种
            if (this.singleRateView || this.ifHistoryPayment) {
              if (charge.chargeCurrency === this.billPayment.currency) {
                rate = 1
              } else if (charge.chargeCurrency === this.otherCurrencyArray[0]) {
                rate = isNaN(this.billPayment.rate) ? 0.0 : this.billPayment.rate
              } else {
                rate = await RateUtil.getForeignExchangeRateSafely(
                  this.billPayment.currency,
                  charge.chargeCurrency,
                  new Date(),
                  this.billPayment.branchId
                )
              }
            } else {
              rate = this.currencyRateMap[charge.chargeCurrency]
            }
          }
          charge.chargeRate = rate
          // CARGO-30308 ID：1887 烽沛 付款申请金额与开票金额相差0.01
          if (charge.chargeReceivable) {
            // amount -= charge.chargeAmount * rate
            amount -= RateUtil.getAmountByCurrency(
              NumberUtils.ToFixed2(charge.chargeAmount * rate, 2),
              this.billPayment.currency
            )
          } else {
            // amount += charge.chargeAmount * rate
            amount += RateUtil.getAmountByCurrency(
              NumberUtils.ToFixed2(charge.chargeAmount * rate, 2),
              this.billPayment.currency
            )
          }
        }
      }
      // this.billPayment.amount = NumberUtils.ToFixed2(amount, 2)
      this.billPayment.amount = NumberUtils.ToFixed2(
        RateUtil.getAmountByCurrency(amount, this.billPayment.currency),
        2
      )
    },
    // 刷新不含税金额（WHT相关）
    refreshChargeNotWhtAmount() {
      let amount = 0.0
      if (this.rowData && this.rowData.length > 0 && this.showWhtTax) {
        for (const charge of this.rowData) {
          amount += charge.chargeNotWhtAmount || 0.0
        }
        this.billPayment.chargeNotWhtAmount = NumberUtils.ToFixed2(amount, 2)
      }
    },
    // 汇率变更事件
    rateChange() {
      this.refreshAmount()
    },
    // 开户银行变更事件
    titleBankChange(titleBank) {
      if (titleBank) {
        this.billPayment.buyerBank = titleBank['bank']
        this.billPayment.buyerBankAccount = titleBank['bankAccount']
        this.buyerBankUuid = titleBank['uuid']
      } else {
        this.billPayment.buyerBank = ''
        this.billPayment.buyerBankAccount = ''
        this.buyerBankUuid = ''
      }
    },
    // 加入费用
    async addCharge() {
      const keys = []
      if (this.rowData && this.rowData.length > 0) {
        for (const charge of this.rowData) {
          if (keys.indexOf(charge.uuid) < 0) {
            keys.push(charge.uuid)
          }
        }
      }
      this.joinChargeDialog.addChargeCondition.accountId = this.billPayment.accountId
      this.joinChargeDialog.addChargeCondition.hasBillPayment = 0
      this.joinChargeDialog.addChargeCondition.isShowWriteOff = 0
      this.joinChargeDialog.addChargeCondition.exceptKeys = keys
      this.joinChargeDialog.visible = true
    },
    // 加入费用回调函数
    async addChargeCallBack(charges = []) {
      if (charges && charges.length > 0) {
        let chargesAdded = this.billPayment.chargesAdded
        const chargesRemoved = this.billPayment.chargesRemoved
        for (const charge of charges) {
          // 1.判断添加费用的集合是否存在，不存在则初始化变量
          if (!chargesAdded) {
            chargesAdded = []
          }
          const index = chargesAdded.findIndex(p => p.uuid === charge.uuid)
          if (index < 0) {
            chargesAdded.push({ uuid: charge.uuid, version: charge.version })
          }
          // 2.校验新添加的费用是否在移除的费用中，有则移除
          if (chargesRemoved && chargesRemoved.length > 0) {
            const delIndex = chargesRemoved.findIndex(p => p.uuid === charge.uuid)
            if (delIndex > -1) {
              chargesRemoved.splice(delIndex, 1)
            }
          }
        }
        this.billPayment.chargesAdded = chargesAdded
        this.billPayment.chargesRemoved = chargesRemoved
        // 更新费用列表
        this.rowData = this.rowData.concat(charges)
        this.rowData.forEach(e => {
          if (!e.chargeBillUuid) {
            e.chargeBillUuid = e.billingUuid
          }
        })
        // 重新计算付款申请金额以及分币种合计
        if (!this.singleRateView) {
          await this.getChargeBillingMultiCurrencyInfo()
        }
        this.currencyChange(this.billPayment.currency)
        this.calCurrencyAmount()
        this.joinChargeDialog.visible = false
      }
    },
    showInvoicePoolDialog() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpense'))
        return
      }
      const invoicedCharge = chooseRows.find(row => isChargeAssociatedWithInvoice(row))
      if (invoicedCharge) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ChargeAlreadyAssociatedInvoice', [buildChargeAssociationLabel(invoicedCharge, this.resolveChargeItemLabel)]))
        return
      }
      Object.assign(this.invoicePoolDialog, buildInvoicePoolOpenState(chooseRows))
      this.invoicePoolDialog.visible = true
    },
    resolveChargeItemLabel(row) {
      return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', row.chargeChargeItemId, 'zhName')
    },
    async invoicePoolCallBack(invoices = []) {
      console.log('[BillPayment] invoicePoolCallBack', { invoiceCount: Array.isArray(invoices) ? invoices.length : 0, rowCount: Array.isArray(this.rowData) ? this.rowData.length : 0 })
      await this.refreshChargesAfterInvoiceAssociation(invoices)
      this.invoicePoolDialog.selectedEntities = []
    },
    async refreshChargesAfterInvoiceAssociation(invoices = []) {
      const chargeUuids = collectChargeUuids(this.rowData)
      if (chargeUuids.length === 0) return
      const res = await loadChargeByUuids(chargeUuids)
      const latestCharges = Array.isArray(res.data) ? res.data : []
      const next = applyLatestCharges({ chargesRemoved: this.billPayment && this.billPayment.chargesRemoved, latestCharges })
      this.rowData = next.rowData
      if (this.billPayment) this.billPayment.chargesRemoved = next.chargesRemoved
      if (this.gridOptions && this.gridOptions.api) {
        this.gridOptions.api.refreshCells({ force: true })
      }
    },
    // 移除费用
    removeCharge() {
      const charges = this.rowData
      const chooseRows = getGridSelected(this.gridOptions)
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpense'))
        return
      }
      if (charges.length === chooseRows.length) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CanNotRemovedAllCharge'))
        return
      }
      this.$confirm(
        this.$t('CargoMsg.Cargo_SureToRemoveTheExpenseItem', [chooseRows.length]),
        this.$t('common.tips.prompt'),
        {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }
      )
        .then(async() => {
          for (const removedCharge of chooseRows) {
            const index = charges.findIndex(p => p.uuid === removedCharge.uuid)
            if (index > -1) {
              // 1.从费用明细列表中移除
              charges.splice(index, 1)
              // 2.是否有被移除的费用集合，没有则初始化变量
              if (!this.billPayment.chargesRemoved) {
                this.billPayment.chargesRemoved = []
              }
              const charge = {}
              charge.uuid = removedCharge.uuid
              charge.version = removedCharge.version
              // 3.先判断是否有进行过添加费用操作
              if (this.billPayment.chargesAdded && this.billPayment.chargesAdded.length > 0) {
                const addIndex = this.billPayment.chargesAdded.findIndex(p => p.uuid === charge.uuid)
                if (addIndex > -1) {
                  // 如果有，则直接从chargesAdded移除
                  this.billPayment.chargesAdded.splice(addIndex, 1)
                }
              }
              // 4. 判断删除的集合中是否包含本次移除的费用，如果没有，则添加到移除集合中。
              const delIndex = this.billPayment.chargesRemoved.findIndex(p => p.uuid === charge.uuid)
              if (removedCharge.billPaymentUuid) {
                // 已关联的付款申请
                if (delIndex < 0) {
                  this.billPayment.chargesRemoved.push(charge)
                }
              } else {
                // 没有关联付款申请的，直接移除掉
                if (delIndex >= 0) {
                  this.billPayment.chargesRemoved.splice(delIndex, 1)
                }
              }
            }
            if (!this.singleRateView) {
              await this.getChargeBillingMultiCurrencyInfo()
            }
            this.currencyChange(this.billPayment.currency)
            this.calCurrencyAmount()
          }
        })
        .catch(() => {})
    },
    // 上一步
    toPreStep() {
      this.$emit('toPreStep', 'step1')
      // 业务模块-国内国外账单页签
      this.$emit('toPreStepForBusiness', 'step1')
    },
    // 计算分币种合计
    calCurrencyAmount() {
      const charges = this.rowData
      let currencyAmount = ''
      if (charges && charges.length > 0) {
        const currencyMap = new Map()
        for (const charge of charges) {
          const chargeCurrency = charge.chargeCurrency
          const amount = isNaN(charge.chargeAmount) ? 0 : charge.chargeAmount
          const receivable = charge.chargeReceivable
          if (!receivable) {
            if (!currencyMap.has(chargeCurrency)) {
              currencyMap.set(chargeCurrency, amount)
            } else {
              const total = currencyMap.get(chargeCurrency)
              // currencyMap.set(chargeCurrency, total + amount)
              currencyMap.set(chargeCurrency, RateUtil.getAmountByCurrency(total + amount, chargeCurrency))
            }
          } else {
            if (!currencyMap.has(chargeCurrency)) {
              currencyMap.set(chargeCurrency, amount === 0 ? 0 : -amount)
            } else {
              const total = currencyMap.get(chargeCurrency)
              // currencyMap.set(chargeCurrency, total + (-amount))
              currencyMap.set(
                chargeCurrency,
                RateUtil.getAmountByCurrency(total + (amount === 0 ? 0 : -amount), chargeCurrency)
              )
            }
          }
        }
        currencyMap.forEach(function(value, key) {
          // currencyAmount += key + ':' + NumberUtils.formatNumber(NumberUtils.ToFixed2(value, 2), 2) + ';'
          currencyAmount +=
            key +
            ':' +
            NumberUtils.formatNumber(NumberUtils.ToFixed2(RateUtil.getAmountByCurrency(value, key), 2), 2) +
            ';'
        })
      }
      this.billPayment.currencyAmount = currencyAmount
    },
    // 提交按钮触发事件（包含特殊审批校验）
    async doCommitPre() {
      if (this.commitSubmitting) return
      this.commitSubmitting = true

      if (!this.billPayment.uuid || !this.billPayment.version) {
        this.commitSubmitting = false
        return
      }

      // 新审批流
      if (this.viewSource === 'billPaymentNew') {
        this.workFlowApplyDialog.visible = true
        this.commitSubmitting = false
        return
      }

      // 旧审批流开关：部分入口不支持启动旧审批
      if (parseInt(cache.config.get('BPM_StartOldApproval')) === 0) {
        if (this.viewSource === 'billPayment') {
          this.$message.warning(this.$t('CargoMsg.Cargo_NotSupportStartOldApprove'))
          this.commitSubmitting = false
          return
        } else {
          this.workFlowApplyDialog.visible = true
          this.commitSubmitting = false
          return
        }
      }

      // 专项付款申请类型时校验付款申请费用和毛利两倍差额审批
      if (this.billPayment.paymentType === '1') {
        const company = await Company.getCompanyById(this.billPayment.accountId)
        if (company) {
          const data = await checkBillPaymentJobSettleFunc({
            billPaymentKey: this.billPayment.uuid,
            checkSpecial: company.specialFeePaymentLimit
          }).then(res => res.data)
          const settleCheck = normalizeBillPaymentJobSettleCheck(data)
          if (settleCheck.applyStatus === 'NEED_APPROVAL') {
            this.specialDialog.visible = true
            this.commitSubmitting = false
            return
          } else if (settleCheck.applyStatus === 'NOT_SETTLE') {
            // 应收费用未结清
            this.$message.warning(this.$t('CargoMsg.Cargo_ThePaymentNotSettled', [settleCheck.applyReason]))
            this.commitSubmitting = false
            return
          }
        }
      }

      // 0 无票，1 有票
      this.billPayment.lackInvoiceFlag = await this.isLackInvoice()
      if (this.billPayment.lackInvoiceFlag === 0 && this.billPayment.paymentType === '0') {
        try {
          await this.$confirm(this.$t('Message.lackInvoiceConfirm'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning'
          })
        } catch (e) {
          // 取消或关闭确认弹窗，不继续提交
          this.commitSubmitting = false
          return
        }
      }
      await this.doCommit()
      this.commitSubmitting = false
    },
    // 判断当前付款申请是否缺少发票文件（没有任何文件勾选“是否发票”）
    async isLackInvoice() {
      if (!this.billPayment || !this.billPayment.uuid) return 0
      try {
        const res = await checkLackInvoiceFlagFunc({ uuid: this.billPayment.uuid })
        return res.data
      } catch (e) {
        // 查询失败时不影响提交流程（返回 null 交由调用方决定是否覆盖标记/阻断）
        return 0
      }
    },
    // 提交（needApproval=true：走“特殊审批”发起后提交）
    doCommit(needApproval = false) {
      const keys = [{ uuid: this.billPayment.uuid, version: this.billPayment.version }]
      const state = this.isDirectPayment ? 2 : 1
      const params = {
        billPayments: keys,
        state: state,
        operation: 'commit',
        approveHistoryPlatform: true,
        needApproval: needApproval
      }
      updateBillPaymentState(params)
        .then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_SubmittedSuccessfully'))
          this.billPayment.state = state
          this.$emit('saveSuccess', [this.billPayment])
          this.$emit('reloadData', { uuid: this.billPayment.uuid })
          return
        })
        .catch()
        .finally()
    },
    // 打印按钮触发事件
    doPrint() {
      this.templateSelectorDialog.data.BILLPAYMENT_UUID = this.billPayment.uuid
      this.templateSelectorDialog.data.BILL_PAYMENT_UUID = this.billPayment.uuid
      this.templateSelectorDialog.category = 'BILLPAYMENT'
      if (this.job) {
        // 国内账单、国外账单使用
        this.billPayment.currentJobNo = this.job.jobNo
        this.templateSelectorDialog.data.classNameType = SystemConstants.ACT
        this.templateSelectorDialog.cxt = new BillPayment(this.billPayment)
      }
      this.templateSelectorDialog.visible = true
    },
    // 办理按钮点击事件（与 BillPaymentByJob 保持一致：审批通过且未全部核销的付款申请才允许自动销账）
    processPaymentRequest() {
      const bp = this.billPayment
      if (!bp || !bp.uuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
        return
      }

      // state: 10=审批通过；realClearingState: 2=全部核销
      if (bp.state !== 10 || bp.realClearingState === 2) {
        this.$message.error(this.$t('CargoMsg.Cargo_OnlyApprovedAndNotFullyWrittenOffCanProcess'))
        return
      }

      this.$confirm(
        this.$t('CargoMsg.Cargo_ConfirmAutoWriteOffSelectedPaymentRequests'),
        this.$t('CargoMsg.Cargo_Tips'),
        {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }
      )
        .then(async() => {
          const loading = getLoading4Cxt(this)
          await autoBillPaymentWriteOffFunc([bp.uuid])
            .then(res => {
              if (res) {
                this.$message.success(this.$t('CargoMsg.Cargo_ProcessSuccessWrittenOff', [res.data || 0]))
                // 刷新详情 & 通知列表刷新
                this.queryBillPayment(bp.uuid)
                this.$emit('reloadData', { uuid: bp.uuid })
              }
            })
            .catch(err => {
              this.$message.error((err && err.message) || this.$t('CargoMsg.Cargo_ProcessFailed'))
            })
            .finally(() => {
              loading.close()
            })
        })
        .catch(() => {
          // 取消操作
        })
    },
    // 执行发起专项费用超出毛利两倍审批
    async doApproval() {
      if (this.$refs.specialForm) {
        const valid = await new Promise(resolve => {
          this.$refs.specialForm.validate(ok => resolve(ok))
        })
        if (!valid) {
          return
        }
      }
      if (!this.specialDialog.applyContent) {
        this.$message.warning(this.$t('CargoMsg.Validation_ApplicationContentRequired'))
        return
      }
      if (!this.specialDialog.applyReason) {
        this.$message.warning(this.$t('CargoMsg.Validation_ApplicationReasonRequired'))
        return
      }
      this.specialDialog.billPaymentUuid = this.billPayment.uuid
      const payload = {
        billPaymentUuid: this.specialDialog.billPaymentUuid,
        applyMatter: this.specialDialog.applyMatter,
        applyContent: this.specialDialog.applyContent,
        applyReason: this.specialDialog.applyReason,
        fileList: (this.specialDialog.fileList || [])
          .map(f => (f && f.fileId) || f)
          .filter(Boolean)
      }
      const loading = getLoading4Cxt(this)
      await initiateSpecialApprovalFunc(payload)
        .then(async res => {
          if (res && res.ok) {
            this.specialDialog.visible = false
            await this.doCommit(true)
          }
        })
        .finally(() => {
          this.specialDialog.billPaymentUuid = ''
          this.specialDialog.applyContent = ''
          this.specialDialog.applyReason = ''
          this.specialDialog.fileList = []
          loading.close()
        })
    },
    hasUploadedSpecialFile() {
      return !!(this.specialDialog && this.specialDialog.fileList && this.specialDialog.fileList.length > 0)
    },
    getSpecialUploadedFileName() {
      const files = (this.specialDialog && this.specialDialog.fileList) || []
      const names = files
        .map(f => (f && (f.fileName || f.name)) || '')
        .filter(Boolean)
      if (names.length > 0) {
        return names.join(', ')
      }
      return this.$t('SeaExport.UploadedFile')
    },
    handleRemoveSpecialUpload() {
      this.specialDialog.fileList = []
    },
    // 上传文件后会回调
    async uploadSuccess(rowData) {
      try {
        for (const data of rowData) {
          if (data.fileId) {
            this.specialDialog.fileList.push({
              fileId: data.fileId,
              fileName: data.fileName || data.name || ''
            })
          }
        }
        this.cloudFile.visible = false
      } catch (e) {
        console.log(e)
      }
    },
    // 取消事件
    cancel() {
      this.btnSaveEnable = false
      this.$emit('cancel')
      if (this.source === 'append') {
        console.log('销毁', this)
        this.$emit('toPreStep', 'step1')
        // this.destroySelf()
      }
      console.log('activeTabName', this.activeTabName)
      this.activeTabName = 'applicationForm'
    },
    // CARGO-47266 P0-创建付款申请增加校验条件，费用复核后才能创建付款申请（费用复核的状态为费用的发票复核的节点）
    async doSavePre() {
      // 判断付款申请类型是否未专项费用申请，若是，则校验费用必须全部是专项费用
      if (this.billPayment.paymentType === '1') {
        let needBlock = false
        for (const item of this.rowData) {
          // 若费用的费用项和结算对象不为专项费用或专项费用资金，则提示且阻断
          if (item.chargeChargeItemId !== 82) {
            needBlock = true
            break
          }

          // 不是专项拓展自己和测试全角色需要拦截
          if (item.chargeAccountId !== 4106 && item.chargeAccountId !== 516) {
            needBlock = true
            break
          }
        }
        if (needBlock) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PaymentOnlySpecificCosts'))
          return
        }
      }
      // 企微必填字段校验：基于后端下发配置中 required=true 的字段，从 this.billPayment 中取值判断（REQ-0033）
      if (this.showEnterpriseWechatFields && this.billPayment) {
        const requiredFields = this.enterpriseWechatFields.filter(f => f && f.prop && f.required)
        const missingField = requiredFields.find(field => !this.hasEnterpriseWechatFieldValue(field))
        if (missingField) {
          const label = this.getEnterpriseWechatLabel(missingField) || missingField.prop
          this.$message.warning(this.$t('Payment.enterpriseWechatFieldRequired', [label]))
          return
        }
      }
      // 0 无票，1 有票
      this.billPayment.lackInvoiceFlag = await this.isLackInvoice()
      // 判断是否开启验证规则
      const useCheckRule = Number(cache.config.get('useCheckRule')) === 1
      // 查询是否存在节点
      const checkNodeFlag = await JobUtils.hasCheckRuleCondition(
        true,
        CheckRuleConstants.NODE_BILL_PAYMENT_SAVE.code,
        this.$store.getters.currentOfficeId
      )
      const billPayments = []
      if (useCheckRule && checkNodeFlag) {
        this.batchCheckingWindow.checkNode = CheckRuleConstants.NODE_BILL_PAYMENT_SAVE.code
        this.rowData.forEach(item => {
          item.lob = item.jobLob
          item.chargeUuid = item.uuid
          item.jobNo = item.jobJobNo
        })
        if (this.billPayment.hasOwnProperty('currencyRateMap') && !this.billPayment.currencyRateMap) {
          delete this.billPayment.currencyRateMap
        }
        if (this.billPayment.hasOwnProperty('chargesAdded') && !this.billPayment.chargesAdded) {
          delete this.billPayment.chargesAdded
        }
        if (this.billPayment.hasOwnProperty('chargesRemoved') && !this.billPayment.chargesRemoved) {
          delete this.billPayment.chargesRemoved
        }
        if (this.billPayment.hasOwnProperty('charges') && !this.billPayment.charges) {
          delete this.billPayment.charges
        }
        if (this.billPayment.hasOwnProperty('dirtyKeyList') && !this.billPayment.dirtyKeyList) {
          delete this.billPayment.dirtyKeyList
        }
        if (this.billPayment.hasOwnProperty('billPayments') && !this.billPayment.billPayments) {
          delete this.billPayment.billPayments
        }
        if (this.billPayment.hasOwnProperty('mapCharge') && !this.billPayment.mapCharge) {
          delete this.billPayment.mapCharge
        }
        if (this.billPayment.hasOwnProperty('params') && !this.billPayment.params) {
          delete this.billPayment.params
        }
        billPayments.push(this.billPayment)
        this.batchCheckingWindow.billPayments = billPayments
        this.batchCheckingWindow.jobs = this.rowData
        this.batchCheckingWindow.callBack = this.doSave
        this.batchCheckingWindow.callBack2 = null
        this.batchCheckingWindow.visible = true
      } else {
        await this.doSave()
      }
    },
    // 保存
    async doSave() {
      this.btnSaveEnable = true
      const validate = await this.validateForm()
      if (!validate) {
        this.btnSaveEnable = false
        return
      }
      const upsertOk = await this.upsertPartnerTitleBankIfNeeded()
      if (!upsertOk) {
        this.btnSaveEnable = false
        return
      }
      const billPayment = this.billPayment
      this.billPayment.chineseAmount = RMBBigTransForm.toBigAmt(NumberUtils.ToFixed2(this.billPayment.amount, 2))
      if (!billPayment.settlementAgentId) {
        billPayment.settlementAgentId = 0
      }
      billPayment.branchId = this.$store.getters.currentOfficeId
      billPayment.currencyRateMap = this.currencyRateMap
      billPayment.singleRateView = this.singleRateView
      billPayment.ifHistoryPayment = this.ifHistoryPayment
      if (Object.keys(this.currencyRateMap).length === 0) {
        delete billPayment.currencyRateMap
      }
      if (!billPayment.uuid) {
        // 新增
        billPayment.jobNo = ''
        billPayment.costInvoiceNo = ''
        billPayment.customerId = -1
        billPayment.inputBy = this.$store.getters.userInfo.userId
        billPayment.inputByDep = this.$store.getters.currentDeptId
        // 随机取第一条费用，将相关属性设置到付款申请上
        this.setBillPaymentProperties(this.rowData[0])
        await this.checkAmountData(billPayment)
        if (this.existDistinctTitle) {
          this.$confirm(this.$t('Message.InvoiceHeaderDifferent'), this.$t('Message.Tips'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning'
          })
            .then(() => {
              this.createBillPayment(billPayment)
            })
            .catch(() => {})
            .finally(() => {
              this.btnSaveEnable = false
            })
        } else {
          this.createBillPayment(billPayment)
        }
        this.saveDefaultContent()
      } else {
        // 更新
        if (billPayment.chargesRemoved) {
          let jobNoExist = false
          for (const charge of this.rowData) {
            if (billPayment.jobNo === charge.jobJobNo) {
              jobNoExist = true
              break
            }
          }
          // 若付款申请总不存在该业务编号，则重新将相关属性设置到付款申请上
          if (!jobNoExist) {
            this.setBillPaymentProperties2(this.rowData[0])
          }
        }
        for (const charge of this.rowData) {
          if (!charge.billPaymentUuid) {
            const map = {}
            map.uuid = charge.uuid
            map.version = charge.version
            if (!billPayment.chargesAdded) {
              billPayment.chargesAdded = []
              billPayment.chargesAdded.push(map)
            } else {
              const addIndex = billPayment.chargesAdded.findIndex(p => p.uuid === map.uuid)
              if (addIndex < 0) {
                billPayment.chargesAdded.push(map)
              }
            }
          }
        }
        delete billPayment.mapCharge
        delete billPayment.params
        if (!billPayment.chargesAdded) {
          delete billPayment.chargesAdded
        }
        if (!billPayment.chargesRemoved) {
          delete billPayment.chargesRemoved
        }
        await this.checkAmountData(billPayment)
        billPayment.inputByDep = this.$store.getters.currentDeptId
        if (this.existDistinctTitle) {
          this.$confirm(this.$t('Message.InvoiceHeaderDifferent'), this.$t('Message.Tips'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning'
          })
            .then(() => {
              this.updateBillPayment(billPayment)
            })
            .catch(() => {})
            .finally(() => {
              this.btnSaveEnable = false
            })
        } else {
          this.updateBillPayment(billPayment)
        }
        this.saveDefaultContent()
      }
    },
    // 后端会根据参数 重新计算付款申请金额，与前端传递金额对比
    async checkAmountData(billPayment) {
      billPayment.mapCharge = []
      for (const charge of this.rowData) {
        const map = {}
        map.uuid = charge.uuid
        map.version = charge.version
        billPayment.mapCharge.push(map)
      }
      billPayment.params = {}
      await cache.load(cacheName.CONFIG)
      billPayment.params.isCheck = await Number(cache.config.get('isCheckBillPaymentAmount'))
      billPayment.params.otherCurrency =
        this.otherCurrencyArray && this.otherCurrencyArray.length > 0 ? this.otherCurrencyArray[0] : ''
      billPayment.params.txtRate = billPayment.rate
      billPayment.params.rateByCharge = this.billPayment.rateByCharge
    },
    createBillPayment(billPayment) {
      const loading = getLoading4Cxt(this)
      const payload = this.buildBillPaymentPayload(billPayment)
      payload.location = this.location
      createBillPayment(payload)
        .then(res => {
          if (res.data) {
            // 校验费用是否被修改并界面提示
            if (res.data.dirtyKeyList && res.data.dirtyKeyList.length > 0) {
              for (const item of this.rowData) {
                if (res.data.dirtyKeyList.includes(item.uuid)) {
                  item.ifDirty = true
                }
                this.rowData = [...this.rowData]
              }
              this.$message.error(res.data.dirtyMsg)
            } else {
              // 直接使用后端返回的最新数据，并重取企微表单配置进行反显
              this.billPayment = res.data
              this.loadEnterpriseWechatFormConfig()
              if (!this.createSubmit) {
                this.$emit('reloadData', res.data)
                this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
                if (this.billPayment.uuid) {
                  this.queryChargeOfBillPayment(this.billPayment.uuid)
                }
              } else {
                if (this.billPayment.uuid) {
                  this.queryChargeOfBillPayment(this.billPayment.uuid)
                }
                this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
              }
            }
          } else {
            this.$message.error(this.$t('Clearing.CreatingFormFailedPleaseAgain'))
          }
        })
        .finally(() => {
          loading.close()
          this.btnSaveEnable = false
        })
    },
    updateBillPayment(billPayment) {
      const loading = getLoading4Cxt(this)
      const payload = this.buildBillPaymentPayload(billPayment)
      payload.location = this.location
      updateBillPayment(payload)
        .then(res => {
          if (res.data) {
            if (res.data.dirtyKeyList && res.data.dirtyKeyList.length > 0) {
              for (const item of this.rowData) {
                if (res.data.dirtyKeyList.includes(item.uuid)) {
                  item.ifDirty = true
                }
                this.rowData = [...this.rowData]
              }
              this.$message.error(res.data.dirtyMsg)
            } else {
              // 更新后使用后端最新数据，并重取企微表单配置进行反显
              this.billPayment = res.data
              this.loadEnterpriseWechatFormConfig()
              if (!this.createSubmit) {
                this.$message.success(this.$t('CargoMsg.Cargo_UpdatedSuccessfully'))
                this.$emit('reloadData', res.data)
              } else {
                this.$message.success(this.$t('CargoMsg.Cargo_UpdatedSuccessfully'))
              }
              if (this.billPayment.uuid) {
                this.queryChargeOfBillPayment(this.billPayment.uuid)
              }
            }
          }
        })
        .finally(() => {
          loading.close()
          this.btnSaveEnable = false
        })
    },
    async upsertPartnerTitleBankIfNeeded() {
      const paymentType = this.billPayment && this.billPayment.paymentType
      if (paymentType === undefined || paymentType === null || paymentType === '') return true
      const typeName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PaymentType, 'code', paymentType, 'name')
      if (typeName !== '日常付款申请' && typeName !== '月结付款申请') return true

      const invoiceTitle =
        this.billPayment && typeof this.billPayment.invoiceTitle === 'string'
          ? this.billPayment.invoiceTitle.trim()
          : this.billPayment.invoiceTitle
      if (!invoiceTitle) {
        this.$message.warning(this.$t('Payment.enterpriseWechatFieldRequired', [this.$t('Payment.invoiceHeader')]))
        return false
      }
      const bank =
        this.billPayment && typeof this.billPayment.buyerBank === 'string'
          ? this.billPayment.buyerBank.trim()
          : this.billPayment.buyerBank
      if (!bank) {
        this.$message.warning(this.$t('Payment.enterpriseWechatFieldRequired', [this.$t('Payment.bankOfDeposit')]))
        return false
      }
      const bankAccount =
        this.billPayment && typeof this.billPayment.buyerBankAccount === 'string'
          ? this.billPayment.buyerBankAccount.trim()
          : this.billPayment.buyerBankAccount
      if (!bankAccount) {
        this.$message.warning(this.$t('Payment.enterpriseWechatFieldRequired', [this.$t('Payment.bankAccount')]))
        return false
      }
      const companyId = Number(this.billPayment && this.billPayment.accountId)
      if (!companyId) {
        this.$message.warning(this.$t('Payment.enterpriseWechatFieldRequired', [this.$t('Payment.settleAccountsTo')]))
        return false
      }
      const currency =
        this.billPayment && typeof this.billPayment.currency === 'string'
          ? this.billPayment.currency.trim()
          : this.billPayment.currency
      const payload = { invoiceTitle, bank, bankAccount, companyId, currency }
      const loading = getLoading4Cxt(this)
      try {
        await upsertPartnerTitleBank(payload)
        return true
      } catch (e) {
        return false
      } finally {
        loading.close()
      }
    },
    // 校验付款申请单
    async validateForm() {
      if (!this.singleRateView && !this.ifHistoryPayment) {
        const currencyList = this.billPayment.payByBillingRate
          ? this.billCurrencyList
          : Array.from(this.chargeCurrencySet)
        if (currencyList.length > 3) {
          this.$message.warning(this.$t('CargoMsg.Cargo_BillPaymentCurrencyBeyond', [3]))
          return false
        }
      }
      if (!this.ifJc && (!this.billPayment.ourTitle || !String(this.billPayment.ourTitle).trim())) {
        this.$message.warning(this.$t('CargoMsg.Cargo_OurHeader') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return false
      }
      if (!this.billPayment.currency) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectCurrency'))
        return false
      }
      if (this.rowData.length === 0) {
        this.$message.warning(this.$t('Message.PleaseAddCosts'))
        return false
      }
      if (!this.billPayment.deadline && this.deadlineConfig === -1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterPaymentTerm'))
        return false
      }
      if (this.isSpecialExpensePaymentType && !this.billPayment.replaceInvoiceRemark) {
        this.$message.warning(this.$t('Message.replaceInvoiceRemarkRequired'))
        return false
      }

      if (this.openSapConfig && !this.billPayment.settleDepartmentPrefix) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DepartmentPrefixNotSelected'))
        return false
      }
      const aAmount = this.billPayment.amount
      const bAmount = await this.totalChargeAmount()
      if (aAmount !== bAmount) {
        this.$message.warning(this.$t('Message.ApplicationAmountCheck'))
        return false
      }
      if (this.rowData.length > 0) {
        let checkBranch = true
        let checkBranchId = true
        if (this.billPayment.branchId > 0) {
          checkBranchId = await SecurityUtil.checkChargeDetailBranch(this.billPayment.branchId)
        }
        for (let j = 0; j < this.rowData.length; j++) {
          checkBranch = await SecurityUtil.checkChargeDetailBranch(this.rowData[j].chargeBranchId)
          if (!checkBranch) {
            break
          }
        }
        if (!checkBranch && !checkBranchId) {
          this.$message.warning(this.$t('Message.CheckChargeDetailBranch'))
          return false
        }
      }
      if (this.showEnterpriseWechatFields) {
        const missingField = this.enterpriseWechatFields.find(
          field => field && field.required && !this.hasEnterpriseWechatFieldValue(field)
        )
        if (missingField) {
          const label = this.getEnterpriseWechatLabel(missingField) || missingField.prop
          this.$message.warning(this.$t('Payment.enterpriseWechatFieldRequired', [label]))
          return false
        }
      }
      // CARGO-31183 付款申请【应收费用不能大于应付】调整到保存付款申请时进行校验
      // 验证应收费用不能大于应付费用
      if (!this.checkBillPaymentCharge(this.rowData)) {
        this.$message.warning(this.$t('Message.ReceivableCannotMorethanPay'))
        return
      }
      return true
    },
    // 校验整个付款申请的金额必须是应付
    checkBillPaymentCharge(rows) {
      let c1 = 0
      let c2 = 0
      for (const charge of rows) {
        const businessDate = !charge.chargeInputDate ? charge.chargeDateCreated : charge.chargeInputDate
        const localCurrency = RateUtil.localCurrencyByOfficeId(charge.chargeBranchId)
        if (charge.chargeReceivable) {
          c1 +=
            charge.chargeAmount *
            RateUtil.getForeignExchangeRateSafely(
              localCurrency,
              charge.chargeCurrency,
              businessDate,
              charge.chargeBranchId
            )
        } else {
          c2 +=
            charge.chargeAmount *
            RateUtil.getForeignExchangeRateSafely(
              localCurrency,
              charge.chargeCurrency,
              businessDate,
              charge.chargeBranchId
            )
        }
      }
      return c1 === 0 || c2 - c1 >= 0
    },
    // 统计费用总金额
    async totalChargeAmount() {
      let amount = 0
      // CARGO-38807 H5 BUG 销账/付款申请单界面金额合计显示错误 付款金额
      const amountCurrencys = ChargeUtils.getZeroAmountCurrencys(
        this.rowData,
        'chargeCurrency',
        'chargeAmount',
        'chargeReceivable'
      )
      for (const charge of this.rowData) {
        if (amountCurrencys.includes(charge.chargeCurrency)) continue
        let rate = 1
        if (this.billPayment.rateByCharge && this.showRateByCharge) {
          rate = charge.chargeExchangeRate
        } else {
          // CARGO-39011 付款申请支持三币种
          if (this.singleRateView || this.ifHistoryPayment) {
            if (charge.chargeCurrency === this.billPayment.currency) {
              rate = 1
            } else if (
              this.otherCurrencyArray &&
              this.otherCurrencyArray.length > 0 &&
              charge.chargeCurrency === this.otherCurrencyArray[0]
            ) {
              rate = this.billPayment.rate
            } else {
              rate = await RateUtil.getForeignExchangeRateSafely(
                this.billPayment.currency,
                charge.chargeCurrency,
                new Date(),
                this.billPayment.branchId
              )
            }
          } else {
            rate = this.currencyRateMap[charge.chargeCurrency]
          }
        }
        this.chargeRate = rate
        if (charge.chargeReceivable) {
          // amount -= charge.chargeAmount * rate
          amount -= RateUtil.getAmountByCurrency(
            NumberUtils.ToFixed2(charge.chargeAmount * rate, 2),
            this.billPayment.currency
          )
        } else {
          // amount += charge.chargeAmount * rate
          amount += RateUtil.getAmountByCurrency(
            NumberUtils.ToFixed2(charge.chargeAmount * rate, 2),
            this.billPayment.currency
          )
        }
      }
      // return NumberUtils.ToFixed2(amount, 2)
      return NumberUtils.ToFixed2(RateUtil.getAmountByCurrency(amount, this.billPayment.currency), 2)
    },
    setBillPaymentProperties(charge) {
      this.billPayment.advance = charge.chargeAdvance
      this.billPayment.accountId = charge.chargeAccountId
      if (!this.billPayment.jobNo) {
        this.billPayment.jobNo = charge.jobJobNo
      } else if (this.billPayment.jobNo !== charge.jobJobNo) {
        this.billPayment.jobNo = ''
      }
      if (!this.billPayment.costInvoiceNo && charge.chargeInvoiceNo) {
        this.billPayment.costInvoiceNo = charge.chargeInvoiceNo
      } else if (this.billPayment.costInvoiceNo !== charge.chargeInvoiceNo && charge.chargeInvoiceNo) {
        this.billPayment.costInvoiceNo = ''
      }
      if (Number('-1') === Number(this.billPayment.customerId)) {
        this.billPayment.customerId = charge.jobCustomerId
      } else if (this.billPayment.customerId > 0 && this.billPayment.customerId !== charge.jobCustomerId) {
        this.billPayment.customerId = 0
      }
    },
    /**
     * 更新付款申请时，若付款申请中业务单号对应的全被移除，则重设相关参数
     * @param charge
     */
    setBillPaymentProperties2(charge) {
      this.billPayment.advance = charge.chargeAdvance
      if (charge.jobJobNo) {
        this.billPayment.jobNo = charge.jobJobNo
      } else {
        this.billPayment.jobNo = ''
      }
      if (charge.chargeInvoiceNo) {
        this.billPayment.costInvoiceNo = charge.chargeInvoiceNo
      } else {
        this.billPayment.costInvoiceNo = ''
      }
      if (Number('-1') === Number(this.billPayment.customerId)) {
        this.billPayment.customerId = charge.jobCustomerId
      } else {
        this.billPayment.customerId = 0
      }
    },
    // tab 页签点击事件
    handleClick(tab, event) {
      console.log(tab, event)
      this.activeTabName = tab.name
    },
    // 审批发起回调
    applyCloseAndRefresh(state) {
      // this.billPayment.state = state
      this.workFlowApplyDialog.visible = false
      // this.$emit('saveSuccess', [this.billPayment])
      this.$emit('cancel')
      this.$emit('reloadData', { uuid: this.billPayment.uuid })
    },
    updateExistDistinctTitle(value = false) {
      this.existDistinctTitle = value
    },
    getTitleArray() {
      // 抬头下拉数据源
      const distinctTitleSet = new Set()
      const titles = []
      this.rowData.forEach(charge => {
        if (charge.chargeInvoiceTitle) {
          if (!distinctTitleSet.has(charge.chargeInvoiceTitle)) {
            distinctTitleSet.add(charge.chargeInvoiceTitle)
            titles.push({ title: charge.chargeInvoiceTitle })
          }
        }
      })
      if (distinctTitleSet.size > 1) {
        this.updateExistDistinctTitle(true)
      } else {
        this.updateExistDistinctTitle(false)
      }
      if (this.defaultTitle && !distinctTitleSet.has(this.defaultTitle)) {
        titles.push({ title: this.defaultTitle })
      }
      this.titleArray = titles
    },
    async getTitleArrayJc() {
      // 抬头下拉数据源，锦昶用
      const titles = []
      await queryTitleByCpmIdx(this.billPayment.accountId).then(res => {
        const data = res.data
        if (data && data.length > 0) {
          data.forEach(title => {
            if (title.defaultTitle && !this.billPayment.invoiceTitle) {
              this.billPayment.invoiceTitle = title.title
            }
            titles.push({ title: title.title })
          })
          if (data.length === 1 && !this.billPayment.invoiceTitle) {
            this.billPayment.invoiceTitle = data[0].title
          }
        }
      })
      this.titleArray = titles
    },
    checkChargeSameTitle() {
      const distinctTitleSet = new Set()
      for (const charge of this.rowData) {
        if (charge.chargeInvoiceTitle) {
          if (distinctTitleSet.size > 0 && !distinctTitleSet.has(charge.chargeInvoiceTitle)) {
            this.existDistinctTitle = true
            break
          }
          distinctTitleSet.add(charge.chargeInvoiceTitle)
        }
      }
    },
    reconciliationTypeChangeHandler() {
      if (this.reconciliationType === 'job') {
        this.queryJobOfBillPayment(this.billPayment.uuid)
      } else if (this.reconciliationType === 'charge') {
        this.queryChargeOfBillPayment(this.billPayment.uuid)
      }
    },
    updatePrintField(selectedTemplate = null) {
      // 只处理打印的逻辑，非打印触发不处理
      if (selectedTemplate && selectedTemplate.previewType) {
        return
      }
      const keys = []
      if (this.templateSelectorDialog.data.BILLPAYMENT_UUID) {
        keys.push(this.templateSelectorDialog.data.BILLPAYMENT_UUID)
      }
      this.loading = getLoading()
      uploadHasPrint(keys)
        .then(res => {
          if (res.ok && res.data) {
            this.billPayment.version = this.billPayment.version
              ? this.billPayment.version + 1
              : this.billPayment.version
            this.$emit('reloadData')
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading.close()
        })
    },
    toSplitCharge() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (!chooseRows || chooseRows.length === 0 || chooseRows.length > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpenseToSplit'))
        return
      }
      const curRow = chooseRows[0]
      const chargeVo = {
        uuid: curRow.uuid,
        jobUuid: curRow.jobUuid,
        chargeItemId: curRow.chargeChargeItemId,
        receivable: curRow.chargeReceivable,
        quantity: curRow.chargeQuantity,
        oversea: curRow.chargeOversea,
        currency: curRow.chargeCurrency,
        measure: curRow.chargeMeasure,
        taxAmount: curRow.chargeTaxAmount,
        taxRate: curRow.chargeTaxRate,
        unitRate: curRow.chargeUnitRate,
        amount: curRow.chargeAmount,
        excludingTaxAmount: curRow.chargeExcludingTaxAmount,
        exchangeRate: curRow.chargeExchangeRate,
        billingAmount: curRow.chargeBillingAmount,
        verifiedAmount: curRow.chargeVerifiedAmount
      }
      this.splitChargeDialog.chargeOrigin = chargeVo // 原始
      this.splitChargeDialog.charge = { ...chargeVo } // 复制
      if (this.splitChargeDialog.charge.verifiedAmount !== 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NonSplitWriteOffExpense'))
        return
      }
      // 费用名称
      this.splitChargeDialog.charge.chargeName = ColumnUtils.resolveColumnLabel(
        TYPE_NAMES.basic_data_ChargeItem,
        'itemId',
        this.splitChargeDialog.charge.chargeItemId,
        'zhName'
      )
      // 含税价保留小数点
      this.splitChargeDialog.charge.amount = NumberUtils.formatRoundNumber(this.splitChargeDialog.charge.amount, 2)
      this.splitChargeDialog.splitCharge.chargeName = this.splitChargeDialog.charge.chargeName
      // 币种
      this.splitChargeDialog.splitCharge.currency = this.splitChargeDialog.charge.currency
      // 税率
      this.splitChargeDialog.splitCharge.taxRate = this.splitChargeDialog.charge.taxRate
      // 重置
      this.splitChargeDialog.splitCharge.amount = 0.0
      this.splitChargeDialog.splitCharge.taxAmount = 0.0
      this.splitChargeDialog.splitCharge.excludingTaxAmount = 0.0
      this.splitChargeDialog.btnSplitEnable = false
      this.splitChargeDialog.onlyChangeQuantity = LocalStorageUtilsNew.hasConfiguration('splitChargeOnlyChangeQuantity')
        ? Boolean(LocalStorageUtilsNew.getConfiguration('splitChargeOnlyChangeQuantity'))
        : true
      this.splitChargeDialog.show = true
    },
    onlyChangeQuantityChangeHandler(value) {
      LocalStorageUtilsNew.setConfiguration('splitChargeOnlyChangeQuantity', this.splitChargeDialog.onlyChangeQuantity)
    },
    // 拆分费用含税金额
    amountChangeHandler(value) {
      this.splitChargeDialog.splitCharge.amount = RateUtil.getAmountByCurrency(
        value,
        this.splitChargeDialog.splitCharge.currency
      )
      this.splitChargeDialog.charge.amount = NumberUtils.roundHalfUp(
        RateUtil.getAmountByCurrency(
          this.splitChargeDialog.chargeOrigin.amount - this.splitChargeDialog.splitCharge.amount,
          this.splitChargeDialog.splitCharge.currency
        ),
        2
      )
      // 不含税金额
      const rAmount = NumberUtils.roundHalfUp(
        RateUtil.getAmountByCurrency(
          this.splitChargeDialog.splitCharge.amount / (this.splitChargeDialog.splitCharge.taxRate / 100 + 1),
          this.splitChargeDialog.splitCharge.currency
        ),
        2
      )
      this.splitChargeDialog.splitCharge.excludingTaxAmount = rAmount
      this.splitChargeDialog.splitCharge.taxAmount = NumberUtils.roundHalfUp(
        RateUtil.getAmountByCurrency(
          this.splitChargeDialog.splitCharge.amount - rAmount,
          this.splitChargeDialog.splitCharge.currency
        ),
        2
      )
      // CARGO-29312，开票详情 费用拆分 提示‘费用金额不等于不含税价加上税额’
      if (RateUtil.useAmountCarryRule()) {
        const c = RateUtil.getAmountByCurrency(
          NumberUtils.ToFixed2(
            this.splitChargeDialog.splitCharge.amount -
              this.splitChargeDialog.splitCharge.excludingTaxAmount -
              this.splitChargeDialog.splitCharge.taxAmount,
            6
          ),
          this.splitChargeDialog.splitCharge.currency
        )
        if (Math.abs(c) !== 0) {
          this.splitChargeDialog.splitCharge.taxAmount = NumberUtils.roundHalfUp(
            RateUtil.getAmountByCurrency(
              this.splitChargeDialog.splitCharge.taxAmount + c,
              this.splitChargeDialog.splitCharge.currency
            ),
            2
          )
        }
      }
    },
    // 确定拆分
    doSplitCharge() {
      this.splitChargeDialog.btnSplitEnable = true
      if (this.splitChargeDialog.splitCharge.amount === 0) {
        this.splitChargeDialog.btnSplitEnable = false
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterSplitAmount'))
      } else if (this.splitChargeDialog.charge.quantity > 1 && !this.splitChargeDialog.onlyChangeQuantity) {
        this.$confirm(this.$t('CargoMsg.Cargo_NOEGT1ICTSTNWBST1C'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        })
          .then(() => {
            this.doSplit()
          })
          .catch(() => {
            this.splitChargeDialog.btnSplitEnable = false
          })
      } else {
        this.doSplit()
      }
    },
    // 拆分
    doSplit() {
      if (this.splitChargeDialog.splitCharge.amount > this.splitChargeDialog.chargeOrigin.amount) {
        this.splitChargeDialog.btnSplitEnable = false
        this.$message.warning(this.$t('Message.TipsOnSplittingExpenses'))
        return
      }
      // 拆分的费用
      this.splitChargeDialog.splitCharge.quantity = 1
      this.splitChargeDialog.splitCharge.billingAmount = 0
      this.splitChargeDialog.splitCharge.unitRate = this.splitChargeDialog.splitCharge.excludingTaxAmount
      // 要拆分的费用
      const rAmount = NumberUtils.roundHalfUp(
        RateUtil.getAmountByCurrency(
          this.splitChargeDialog.charge.amount / (this.splitChargeDialog.charge.taxRate / 100 + 1),
          this.splitChargeDialog.splitCharge.currency
        ),
        2
      )
      this.splitChargeDialog.charge.excludingTaxAmount = rAmount
      this.splitChargeDialog.charge.taxAmount = NumberUtils.roundHalfUp(
        RateUtil.getAmountByCurrency(
          this.splitChargeDialog.charge.amount - rAmount,
          this.splitChargeDialog.splitCharge.currency
        ),
        2
      )
      if (RateUtil.useAmountCarryRule()) {
        const c = RateUtil.getAmountByCurrency(
          NumberUtils.ToFixed2(
            this.splitChargeDialog.charge.amount -
              this.splitChargeDialog.charge.excludingTaxAmount -
              this.splitChargeDialog.charge.taxAmount,
            6
          ),
          this.splitChargeDialog.splitCharge.currency
        )
        if (Math.abs(c) !== 0) {
          this.splitChargeDialog.charge.taxAmount = NumberUtils.roundHalfUp(
            RateUtil.getAmountByCurrency(
              this.splitChargeDialog.charge.taxAmount + c,
              this.splitChargeDialog.splitCharge.currency
            ),
            2
          )
        }
      }
      this.splitChargeDialog.charge.quantity = 1
      this.splitChargeDialog.charge.unitRate = this.splitChargeDialog.charge.excludingTaxAmount
      this.splitChargeDialog.charge.chargeSource = 6
      this.splitChargeDialog.splitCharge.chargeSource = 6
      this.splitChargeDialog.charge.splitChargeOnlyChangeQuantity = this.splitChargeDialog.onlyChangeQuantity
      const charges = []
      charges.push(this.splitChargeDialog.charge)
      charges.push(this.splitChargeDialog.splitCharge)
      this.loading = getLoading()
      saveSplitCharge(charges, this.location)
        .then(res => {
          this.splitChargeDialog.show = false
          const rowData = []
          for (const charge of this.rowData) {
            if (charge.uuid === this.splitChargeDialog.chargeOrigin.uuid) {
              continue
            }
            rowData.push(charge)
          }
          for (const charge of res.data) {
            rowData.push(charge)
          }
          this.rowData = rowData
          this.$message.success(this.$t('CargoMsg.Cargo_SplitSuccessfully'))
        })
        .catch(() => {
          this.splitChargeDialog.btnSplitEnable = false
        })
        .finally(() => {
          this.loading.close()
        })
    },
    // 同步发票附件勾选修改
    saveDefaultContent() {
      const item = {}
      item.paymentType = this.billPayment.paymentType
      item.ourTitle = this.billPayment.ourTitle
      LocalStorageUtilsNew.setConfiguration('billPaymentFormPage', item)
    }
  }
}
</script>

<style lang="scss">
.el-dialog__wrapper {
  &.minSize {
    width: 250px;
    height: 60px;
    top: unset;
    left: unset;
    bottom: -20px;
    right: 0;
    .el-dialog {
      top: 0;
      margin: 0 !important;
    }
  }
}
.bill-payment-dialog {
  display: flex;
  flex-direction: column;
  .custom-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    span,
    i {
      font-size: 16px;
    }
  }
  .el-dialog__body {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 10px !important;
    .tabs-container {
      flex-grow: 1;
      .el-tabs {
        height: 100%;
        display: flex;
        flex-direction: column;
        .el-tabs__content {
          flex-grow: 1;
          .el-tab-pane {
            height: 100%;
            display: flex;
            flex-direction: column;
          }
        }
      }
    }
  }
  .el-scrollbar__wrap {
    overflow-x: auto;
  }
  .custom-textarea {
    textarea {
      resize: none;
    }
  }
  .el-tabs__header {
    margin-bottom: 5px;
  }
  .upload-file-row {
    display: flex;
    align-items: center;
  }
  .upload-file-name {
    max-width: 420px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .upload-file-remove {
    padding: 0 4px;
    margin-left: 6px;
    line-height: 1;
  }
}
</style>
